
import React from 'react';
import {
  Box,
  Paper,
  Typography,
  IconButton,
  Tooltip,
  Chip,
  Divider,
  Drawer,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Tabs,
  Tab,
  Checkbox,
  Snackbar,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Autocomplete,
  FormControlLabel,
  Stepper,
  Step,
  StepLabel,
  Popover,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  LinearProgress,
  ListItemText,
  CircularProgress
} from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import UploadFileIcon from '@mui/icons-material/UploadFile';

import Client from './components/Client';
import Config from './components/ClientConfig';
import ListsCompanyFilters from './components/ListsCompanyFilters';
import {
  todayISO, nowLocalDT, csvCell, downloadBlob,
  toCurrencyCode, toCurrencyName,
  groupLatest, enrichCompanyCounts, 
  isUserTyping,
  companyProductsOf as _companyProductsOf,
  companyCombosOf as _companyCombosOf,
  makeProdKey as _makeProdKey,
  makeComboKey as _makeComboKey,
  stableProdKey as _stableProdKey,
  stableComboKey as _stableComboKey,
  normalizeIds as _normalizeIds,
  exportCompanyLatestCSV as sharedExportLatestCSV,
  exportCompanyDetailCSV as sharedExportDetailCSV,
  filterByQuery as _filterByQuery,
  filterByOverlap as _filterByOverlap
} from './components/ListsShared';
import Avatar from '@mui/material/Avatar';
import noImage from './images/noImage.png';

// Endpoints / routes used by new features (adjust to your backend)
const PRODUCTS_ENDPOINT = (Config.API_URL_PRODUCT);
const COMBOS_ENDPOINT   = (Config.API_URL_COMBO);
const UPDATE_META_ENDPOINT = () => `${Config.API_URL_LIST_COMPANY}update_meta/`;
const CREATE_EMPTY_ENDPOINT = () => `${Config.API_URL_LIST_COMPANY}create_empty/`;            // create empty list
const QUICK_COPY_ENDPOINT = () => `${Config.API_URL_LIST_COMPANY}copy_list/`;                 // quick copy drafts

const _thumbFromImages = (imgList) => {
  if (!imgList || (Array.isArray(imgList) && imgList.length === 0)) return null;
  const arr = Array.isArray(imgList) ? imgList : [imgList];
  let src = arr[0]?.image || arr[0]?.url || arr[0];
  for (let i = 0; i < arr.length; i++) {
    const t = arr[i];
    if (t?.isMain) { src = t.image || t.url || src; break; }
  }
  if (!src || typeof src !== 'string') return null;
  // keep only one "_s"
  if (/_s(\.[^/.]+)$/.test(src)) return src;
  const dot = src.lastIndexOf('.');
  if (dot > 0) return `${src.slice(0, dot)}_s${src.slice(dot)}`;
  return src;
};

export default class ListsPrice extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      client: new Client('none'),
      locations: {},
      companies: {},
      lists: [],
      rawList: [],
      loading: false,
      readLoading: false,
      error: '',

      drawerOpen: false,
      drawerLocation: null,
      drawerVersions: [],
      drawerLoading: false,
      histCtx: { locationIref: null, currency: null, withVAT: null },

      histLimit: 10,
      histActiveOnly: false,
      histVersion: '',
      _histTimer: null,

      readOpen: false,
      readDetail: null,
      readTab: 0,

      // item edit (creates new version)
      readEditMode: false,
      readEdits: { products: {}, combos: {} },
      readAdds:   { products: [], combos: [] },
      readRemovals: { products: new Set(), combos: new Set() },

      savingItems: false,

      // meta edit (NO new version)
      editPriceList: false,   // <- controls editable state of period/active
      metaDirty: false,
      metaDateFrom: '',
      metaDateTo: '',
      metaIsActive: true,
      metaCreatedOn: '',
      metaShortName: '',

      // preloaded catalogs
      allProducts: [],
      allCombos:   [],
      prodOptions: [],
      comboOptions: [],
      prodSelected: null,
      prodAddQuery: '',
      prodPriceInput: '',
      prodActiveInput: true,
      comboSelected: null,
      comboAddQuery: '',
      comboPriceInput: '',
      comboActiveInput: true,

      qFilters: (()=>{ try{ const saved = JSON.parse(localStorage.getItem('lc_qFilters')||'null'); if(saved&&saved.dateFrom&&saved.dateTo) return saved; }catch(e){} return { company: '', dateFrom: todayISO(), dateTo: todayISO() }; })(),
      showDrafts: JSON.parse(localStorage.getItem('lc_showDrafts') || 'false'),
      trackLock: false,   // when true, we keep location/currency/VAT filters; default false shows all locations

      snack: { open:false, message:'', severity:'success' },
      csvImporting: false,

      // -------- COPY TO… quick action (popover) --------
      copyAnchorEl: null,
      copySource: null,
      copyCompany: '',
      copyDestOptions: [],
      copyDestinations: [],
      copyMode: 'full',  // 'full' | 'partial'
      copyFilters: { categories: [], brands: [], tags: [], changedSince: '' },
      copyEffective: 'now', // 'now' | 'schedule'
      copyWhen: nowLocalDT(),
      copyCreateDraft: true,
      copySubmitting: false,
      copyShortName: '',

      // compare (from v1 back)
      cmpOpen: false,
      cmpBase: null,
      cmpOther: null,
      cmpTab: 0,
      cmpDiff: null,

      confirmCloseOpen:false,
    };
  }

  STATUS_LABELS = {
    0: 'Registered',
    1: 'Idle',
    2: 'Active',
    9: 'Discontinued',
  };
  companyProductsOf = (detail) => _companyProductsOf(detail);
  companyCombosOf = (detail) => _companyCombosOf(detail);
  makeProdKey = (it, idx) => _makeProdKey(it, idx);
  makeComboKey = (it, idx) => _makeComboKey(it, idx);
  stableProdKey = (row) => _stableProdKey(row);
  stableComboKey = (row) => _stableComboKey(row);
  filterByOverlap = (...args) => _filterByOverlap(...args);
  normalizeIds = (...args) => _normalizeIds(...args);

  normalizeProductItem = (it, parent, idx) => {
    // Accept raw ID strings/numbers from "thin" new_version responses
    if (typeof it === 'string' || typeof it === 'number') {
      it = { productRef: { iref: String(it) } };
    }

    // Candidate IDs to match against the product catalog
    const idCands = [
      it?.product?.iref, it?.productRef?.iref,
      it?.product, it?.product_id, it?.productId, it?.productID,
      it?.product_iref, it?.productIref,
      it?.p_id, it?.p_iref,
      it?.sku, it?.code
    ].filter(Boolean).map(String);

    const products = this.state.allProducts || [];
    const ref = products.find(p =>
      idCands.includes(String(p.iref)) || (p.sku && idCands.includes(String(p.sku)))
    );

    // Derive core fields
    const key = this.makeProdKey(it, idx);
    let name = it?.name || it?.product?.name || it?.productRef?.name || (ref?.name || '');
    let sku  = it?.sku  || it?.product?.sku  || it?.productRef?.sku  || (ref?.sku  || '');

    // Price: accept price/value shapes
    const price = this.parsePrice(it?.price ?? it?.value);

    // Image & taxonomy from catalog if present
    let img = it?.img;
    if (!img && ref?.imgList?.length) img = _thumbFromImages(ref.imgList);
    if (!img) img = noImage;

    // Class/Category + unit type (names depend on your product payload)
    const pCategory    = it?.pCategory    || ref?.pCategory    || null; // {name, image}
    const pSubCategory = it?.pSubCategory || ref?.pSubCategory || null; // {name, image}
    const unitType     = it?.unitType     || ref?.unitType     || null;

    // Currency from row or parent detail
    const currency = it?.currency ?? parent?.currency;
    const isForSale = it?.isForSale ?? ref?.isForSale ?? null;
    const isSoldAlone  = it?.isSoldAlone ?? ref?.isSoldAlone ?? null;
    const rawStatus = it?.status ?? ref?.status ?? null;
    const status = this.STATUS_LABELS[rawStatus] ?? '—';

    return {
      ...it,
      key,
      name,
      sku,
      price,
      currency,
      isActive: (it?.isActive != null ? !!it.isActive
                : (it?.active != null ? !!it.active : true)),
      unitType,
      pCategory,
      pSubCategory,
      img,
      isForSale,
      isSoldAlone,
      status,
    };
  };
  normalizeComboItem = (it, parent, idx) => {
    // Accept raw ID strings/numbers
    if (typeof it === 'string' || typeof it === 'number') {
      it = { comboRef: { iref: String(it) } };
    }

    const idCands = [
      it?.productCombo?.iref, it?.comboRef?.iref,
      it?.productCombo, it?.combo_id, it?.comboId, it?.comboID,
      it?.combo_iref, it?.comboIref,
      it?.c_id, it?.c_iref,
      it?.sku, it?.code
    ].filter(Boolean).map(String);

    const combos = this.state.allCombos || [];
    const ref = combos.find(c =>
      idCands.includes(String(c.iref)) || (c.sku && idCands.includes(String(c.sku)))
    );

    const key  = this.makeComboKey(it, idx);
    let name   = it?.name || it?.productCombo?.name || it?.comboRef?.name || (ref?.name || '');
    let sku    = it?.sku  || it?.productCombo?.sku  || it?.comboRef?.sku  || (ref?.sku  || '');

    const price = this.parsePrice(it?.price ?? it?.value);

    // --------- IMAGE (only from combo image model) ----------
    // Look on the row, on nested productCombo, then on the preloaded ref
    let img = it?.img || null;
    const imgList =
      it?.comboImage_productCombo ||
      it?.productCombo?.comboImage_productCombo ||
      ref?.imgList ||
      [];
    if (!img && imgList && imgList.length) {
      img = this.getThumbFromImages(imgList) || null; // ensures "_s"
    }
    if (!img && ref?.thumb) img = ref.thumb;
    if (!img) img = noImage;

    const currency = it?.currency ?? parent?.currency;
    const isForSale = it?.isForSale ?? ref?.isForSale ?? null;
    const rawStatus = it?.status ?? ref?.status ?? null;
    const status = this.STATUS_LABELS[rawStatus] ?? '—';

    return {
      ...it,
      key,
      name,
      sku,
      price,
      currency,
      isActive: (it?.isActive != null ? !!it.isActive
                : (it?.active != null ? !!it.active : true)),
      img,
      isForSale,
      status,
    };
  };

  hasUsablePrices = (d) => {
    const arr = (v) => Array.isArray(v) ? v : Object.values(v || {});
    const pHas = arr(d?.productCompany_list).some(it => {
      const v = (it?.price != null ? it.price : it?.value);
      return v != null && !Number.isNaN(Number(v));
    });
    const cHas = arr(d?.comboCompany_list).some(it => {
      const v = (it?.price != null ? it.price : it?.value);
      return v != null && !Number.isNaN(Number(v));
    });
    return pHas || cHas;
  };

  hasHydratedItems = (d) => {
    const arr = (v) => Array.isArray(v) ? v : Object.values(v || {});
    const pNamed = arr(d?.productCompany_list).some(it =>
      it?.product?.name || it?.productRef?.name || it?.name
    );
    const cNamed = arr(d?.comboCompany_list).some(it =>
      it?.productCombo?.name || it?.comboRef?.name || it?.name
    );
    return pNamed || cNamed;
  };

  fetchDetailByIref = (iref) => {
    try { return this.state.client.getData(`${Config.API_URL_LIST_COMPANY}${iref}/`, {}); }
    catch(e) { return null; }
  };

  // ---------- lifecycle ----------
  componentDidMount(){
    // Reset filters every time we enter this page
    try {
      localStorage.removeItem('lc_qFilters');
      localStorage.removeItem('lc_copy_defaults');
      localStorage.removeItem('lc_showDrafts');
    } catch (e) {}
    const locationsRes = this.state.client.getData(Config.API_URL_LOCATIONS_SIMPLE, {"status_list": [0, 1]});
    if (locationsRes && locationsRes.locations) {
      const locs = locationsRes.locations;
      this.setState({ locations: locs, copyDestOptions: this.buildCopyDestOptions(Object.values(locs)) });
    }
    this.loadCompanies();
    this.preloadCatalogs();
    if (this.state?.qFilters?.location) {
      this.fetchLatest(this.buildQueryFromFilters());
    }
    const persisted = JSON.parse(localStorage.getItem('lc_copy_defaults') || '{}');
    const fixed = this.normalizeIds(persisted.copyDestinations || []);
    if (JSON.stringify(fixed) !== JSON.stringify(persisted.copyDestinations || [])) {
      this.setState({ copyDestinations: fixed });
    }
    // keyboard shortcuts: C (quick copy), Shift+C (wizard)
    window.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount(){
    window.removeEventListener('keydown', this.onKeyDown);
  }

  onKeyDown = (e) => {
    if (!this.state.lists?.length) return;
    if (isUserTyping()) return;
    if (e.key?.toLowerCase() === 'c' && !e.shiftKey) {
      // use first row as default source
      const r = this.state.lists[0];
      this.openCopyPopover(r, { target: { getBoundingClientRect: ()=>({left:window.innerWidth/2, top:80, width:0, height:0}) } });
    } else if (e.key?.toLowerCase() === 'c' && e.shiftKey) {
      this.openWizardFromRow(this.state.lists[0]);
    }
  };

  loadCompanies = () => {
    try {
      const res = this.state.client.getData(Config.API_URL_COMPANY, {"isClient": 1});
      const arr = Array.isArray(res)
        ? res
        : (res?.Companies || res?.companies || res?.results || res?.company || []);
      const map = {};
      (arr || []).forEach(c => {
        const id = String(c?.iref ?? c?.id ?? c?.pk ?? '');
        if (!id) return;
        map[id] = { iref: id, name: (c?.name ?? c?.label ?? id) };
      });
      this.setState({ companies: map });
    } catch {
      this.setState({ companies: {} });
    }
  };

  computeShortName = (companyIrefOrObj) => {
    const id = (typeof companyIrefOrObj === 'object')
      ? (companyIrefOrObj?.iref || '')
      : String(companyIrefOrObj || '');

    const name =
      (typeof companyIrefOrObj === 'object' ? companyIrefOrObj?.name : null) ||
      this.state.companies?.[id]?.name ||
      '';

    return String(name || '').slice(0, 16);
  };

  preloadCatalogs = () => {
    try {
      const pr = this.state.client.getData(PRODUCTS_ENDPOINT, {});
      const products = Array.isArray(pr?.results) ? pr.results : (Array.isArray(pr) ? pr : (pr?.products || []));
      const mappedP = (products || []).map(p => {
        const imgList = p.productImage_product || p.images || p.img || [];
        const pCat = p.pCategory || p.category || null;
        const pSub = p.pSubCategory || p.subCategory || null;
        return {
          iref: p.iref || p.id || p.sku || p.code || p.uuid,
          id: p.id ?? null,
          code: p.code ?? null,
          uuid: p.uuid ?? null,
          name: p.name || '',
          sku: p.sku || '',
          unitType: p.unitType,
          pCategory: pCat ? { name: pCat.name, image: pCat.image } : null,
          pSubCategory: pSub ? { name: pSub.name, image: pSub.image } : null,
          imgList,
          isForSale: p.isForSale ?? p.isSellable ?? null,
          isSoldAlone: p.isSoldAlone ?? null,
          status: p.status ?? null,
          label: p.name || '',
        };
      }).filter(o => o.iref)
      .sort((a,b)=> (a.name||'').localeCompare(b.name||''));
      const cr = this.state.client.getData(COMBOS_ENDPOINT, {});
      const combos = Array.isArray(cr?.results) ? cr.results : (Array.isArray(cr) ? cr : (cr?.productCombos || cr?.combos || []));
      const mappedC = (combos || []).map(c => {
        // Only the dedicated combo image model (as you requested)
        const imgList =
          c.comboImage_productCombo ||            // preferred (your related_name)
          c.comboImage_combo ||                   // fallback if some endpoints still use this
          [];
        // Precompute the small thumb (_s) once
        const thumb = this.getThumbFromImages(imgList) || null;
        return {
          iref: c.iref || c.id || c.sku || c.code || c.uuid,
          id: c.id ?? null,
          code: c.code ?? null,
          uuid: c.uuid ?? null,
          name: c.name || '',
          sku: c.sku || '',
          imgList,
          thumb,
          isForSale: c.isForSale ?? c.isSellable ?? null,
          status: c.status ?? null,
          label: c.name || '',
        };
      }).filter(o => o.iref)
      .sort((a,b)=> (a.name||'').localeCompare(b.name||''));
      this.setState({ allProducts: mappedP, allCombos: mappedC, prodOptions: mappedP.slice(0,50), comboOptions: mappedC.slice(0,50) });
    } catch (e) {
      // ignore preload errors
    }
  };

  applyFilters = (queryData) => {
    const q = { ...(queryData || {}) };
    // normalize before storing
    if (q.currency != null && typeof q.currency !== 'number') {
      q.currency = toCurrencyCode(q.currency);
    }
    if (q.withVAT != null) {
      q.withVAT = (q.withVAT === true || q.withVAT === 'true' || q.withVAT === 1 || q.withVAT === '1') ? 1 : 0;
    }
    if (q.status != null) {
      q.status = (q.status === true || q.status === 'true' || q.status === 1 || q.status === '1') ? 1 : 0;
    }
    if (!q.dateFrom) q.dateFrom = todayISO();
    if (!q.dateTo) q.dateTo = todayISO();
    this.setState({ qFilters: q }, ()=>{
      try{ localStorage.setItem('lc_qFilters', JSON.stringify(q)); }catch(e){}
      this.fetchLatest(this.buildQueryFromFilters());
    });
  };

  fetchLatest = (overrides) => {
    this.setState({ loading: true, error: '' });

    const q = { ...(this.state?.qFilters || {}), ...(overrides || {}) };

    // HARD GUARD: no "all locations" queries
    if (!q.location && !q.iref && !q.locations) {
      this.setState({
        loading: false,
        snack: { open: true, message: 'Please select a location to search.', severity: 'info' }
      });
      return;
    }

    const { dateFrom, dateTo } = q;
    const showDrafts = !!this.state?.showDrafts;

    // Build lean query but ALWAYS pass user filters if present
    const query = {
      ...q,
      thin: 1,
      fields: 'iref,version,isActive,currency,withVAT,dateFrom,dateTo,company,location,description,productCount,comboCount'
    };

    // Normalize currency / VAT
    if (query.currency !== undefined) {
      if (query.currency === '') delete query.currency;      // "All"
      else query.currency = toCurrencyCode(query.currency);
    }
    if (query.withVAT !== undefined) query.withVAT = !!query.withVAT;

    // Default to active only unless drafts/all_versions explicitly requested
    if (query.status == null && !showDrafts && !query.all_versions) {
      query.status = 1;
    }

    // date overlap + latest per track
    if (dateFrom && dateTo) {
      query.dateFrom = dateFrom;
      query.dateTo   = dateTo;
      query.overlap  = 1;
      query.latest_per_track = 1;
    }

    try {
      const res    = this.state.client.getData(Config.API_URL_LIST_COMPANY, query);
      const arrRaw = Array.isArray(res) ? res : (res?.results || res?.companyList || []);
      const arr    = (arrRaw || []).map(r => ({
        ...r,
        withVAT: (r?.withVAT === true || r?.withVAT === 1 || r?.withVAT === '1' ||
                  String(r?.withVAT).toLowerCase() === 'true'),
        currency: (Number.isInteger(r?.currency) ? r.currency : toCurrencyCode(r?.currency)),
      }));

      let lists;
      if (query.all_versions && !this.state.showDrafts) {
        // pair (latest + latest active) per track
        lists = this.latestPlusActivePerTrack(arr);
      } else if (dateFrom && dateTo && this.state.showDrafts) {
        lists = (arr.some(r => r && r.version) ? arr : groupLatest(arr));
      } else {
        lists = groupLatest(arr);
      }

      this.setState({ rawList: arr, lists, loading: false }, this.hydrateCounts);
    } catch (e) {
      this.setState({ error: 'Failed to load company lists', loading: false });
    }
  };

  // Build query so main list shows ALL locations by default and overlap works
  buildQueryFromFilters = () => {
    const q = { ...(this.state?.qFilters || {}) };
    const showDrafts = !!this.state?.showDrafts;
    const params = { ...q };
    if (!showDrafts) {
      // Keep user-chosen status if present; default to active
      if (params.status == null) params.status = 1;
      // If the user picked a date window, explicitly request overlap on the server
      if (params.dateFrom && params.dateTo) params.overlap = 1;
      delete params.all_versions;
      return params;
    }
    // Drafts ON → allow exploring all versions; window optional
    params.all_versions = 1;
    if (params.dateFrom && params.dateTo) params.overlap = 1;
    return params;
  };

  // Latest per track (location|currency|withVAT) from an overlapping set
  groupLatestFromOverlap = (rows, fromISO, toISO) => {
    const overlapped = this.filterByOverlap(rows, fromISO, toISO);
    const map = new Map();
    overlapped.forEach(r => {
      const key = `${r.company?.iref || r.company}|${r.location?.iref || r.location}|${r.currency}|${!!r.withVAT}`;
      const prev = map.get(key);
      if (!prev || Number(r.version) > Number(prev.version)) map.set(key, r);
    });
    return Array.from(map.values());
  };

  latestPlusActivePerTrack = (rows) => {
    const byTrack = new Map();
    (rows || []).forEach(r => {
      const key = `${r.company?.iref || r.company}|${r.location?.iref || r.location}|${r.currency}|${!!r.withVAT}`;
      const arr = byTrack.get(key) || [];
      arr.push(r);
      byTrack.set(key, arr);
    });
    const out = [];
    byTrack.forEach((arr) => {
      const sorted = arr.slice().sort((a,b)=> Number(b.version) - Number(a.version));
      const latest = sorted[0];
      const latestActive = sorted.find(x => !!x.isActive);
      if (latest) out.push(latest);
      if (latestActive && latestActive.iref !== latest.iref) out.push(latestActive);
    });
    // Nice, stable sort by location, then version desc
    return out.sort((a,b)=>{
      const la = (a.location?.name || a.location || '').toString().toLowerCase();
      const lb = (b.location?.name || b.location || '').toString().toLowerCase();
      if (la < lb) return -1; if (la > lb) return 1;
      return Number(b.version) - Number(a.version);
    });
  };

  mergeVersionsByIref = (...lists) => {
    const map = new Map();
    lists.flat().filter(Boolean).forEach((v) => {
      const key = String(v.iref || `${v.version}_${v.dateFrom}_${v.dateTo}`);
      const old = map.get(key) || {};
      map.set(key, { ...old, ...v });
    });
    return Array.from(map.values()).sort((a, b) => Number(b.version || 0) - Number(a.version || 0));
  };

  markTimelineRows = (versions, searchedVersion = '') => {
    const searched = String(searchedVersion || '').trim();
    return (versions || []).map(v => ({
      ...v,
      _isSearchedVersion: searched !== '' && String(v.version) === searched,
    }));
  };

  // ---------- HISTORY ----------
  fetchHistoryForLocation = () => {
    const { histCtx, histLimit = 10 } = this.state;
    if (!histCtx?.locationIref || !histCtx?.companyIref) return;

    const q = this.state.qFilters || {};
    const selectedFrom = q.dateFrom || todayISO();
    const selectedTo = q.dateTo || selectedFrom;

    const baseParams = {
      company: histCtx.companyIref,
      location: histCtx.locationIref,
      currency: toCurrencyCode(histCtx.currency),
      withVAT: !!histCtx.withVAT,
      all_versions: 1,
      history_limit: histLimit,
      ...(this.state.histActiveOnly ? { active_only: 1 } : {}),
    };

    const searchedVersion = String(this.state.histVersion || '').trim();

    this.setState({ drawerLoading: true });

    try {
      // Load period context first, so "effective" is calculated
      // against the real competing versions for this company/location track.
      const periodParams = {
        ...baseParams,
        dateFrom: selectedFrom,
        dateTo: selectedTo,
        overlap: 1,
        history_limit: Math.max(Number(histLimit || 10), 30),
      };

      const periodRes = this.state.client.getData(Config.API_URL_LIST_COMPANY, periodParams);
      const periodList = Array.isArray(periodRes)
        ? periodRes
        : (periodRes?.results || periodRes?.companyList || []);

      let searchedList = [];

      if (searchedVersion !== '') {
        const searchParams = {
          ...baseParams,
          exact_version: Number(searchedVersion),
          history_limit: 1,
        };

        const searchRes = this.state.client.getData(Config.API_URL_LIST_COMPANY, searchParams);
        searchedList = Array.isArray(searchRes)
          ? searchRes
          : (searchRes?.results || searchRes?.companyList || []);
      }

      const merged = this.mergeVersionsByIref(periodList, searchedList)
        .map(enrichCompanyCounts);

      this.setState({
        drawerVersions: this.markTimelineRows(merged, searchedVersion),
        drawerLoading: false
      });
    } catch (e) {
      this.setState({ drawerLoading: false });
    }
  };

  openHistory = (row) => {
    const locIref = row?.location?.iref || row?.location;
    const compIref = row?.company?.iref || row?.company;
    const cur = row?.currency;
    const vat = !!row?.withVAT;
    this.setState({
      drawerOpen: true,
      drawerLocation: row.location,
      drawerCompany: row.company,
      drawerVersions: [],
      drawerLoading: false,
      histLimit: 10,
      histActiveOnly: false,
      histVersion: '',
      histCtx: { companyIref: compIref, locationIref: locIref, currency: cur, withVAT: vat }
    }, () => this.fetchHistoryForLocation());
  };

  getDetailByIref = (iref) => {
    try { return this.state.client.getData(`${Config.API_URL_LIST_COMPANY}${iref}/`, {}); }
    catch (e) { return null; }
  };

  arrayizeProductList = (listLike) => {
    if (Array.isArray(listLike)) return listLike;
    const out = [];
    const obj = (listLike || {});
    Object.entries(obj).forEach(([k, v]) => {
      if (v == null) return;
      if (typeof v === 'object') {
        out.push({ ...v, productRef: v.productRef || v.product || { iref: String(k) } });
      } else {
        // primitive = price (number/string) from thin payload
        const price = this.parsePrice(v);
        out.push({ productRef: { iref: String(k) }, price });
      }
    });
    return out;
  };

  arrayizeComboList = (listLike) => {
    if (Array.isArray(listLike)) return listLike;
    const out = [];
    const obj = (listLike || {});
    Object.entries(obj).forEach(([k, v]) => {
      if (v == null) return;
      if (typeof v === 'object') {
        out.push({ ...v, comboRef: v.comboRef || v.productCombo || { iref: String(k) } });
      } else {
        const price = this.parsePrice(v);
        out.push({ comboRef: { iref: String(k) }, price });
      }
    });
    return out;
  };

  hydrateDetailWithCatalogs = (detail) => {
    if (!detail) return detail;
    const pArr = this.state.allProducts || [];
    const cArr = this.state.allCombos || [];
    const pIdx = new Map();
    pArr.forEach(p => {
      if (p.iref) pIdx.set(String(p.iref), p);
      if (p.id != null) pIdx.set(String(p.id), p);
      if (p.sku) pIdx.set(String(p.sku), p);
      if (p.code) pIdx.set(String(p.code), p);
      if (p.uuid) pIdx.set(String(p.uuid), p);
    });
    const cIdx = new Map();
    cArr.forEach(c => {
      if (c.iref) cIdx.set(String(c.iref), c);
      if (c.id != null) cIdx.set(String(c.id), c);
      if (c.sku) cIdx.set(String(c.sku), c);
      if (c.code) cIdx.set(String(c.code), c);
      if (c.uuid) cIdx.set(String(c.uuid), c);
    });

    const fixP = (arr) => this.arrayizeProductList(arr).map(it => {
      if (typeof it === 'string' || typeof it === 'number') {
        const id = String(it);
        const ref = pIdx.get(id);
        return ref ? { productRef: { iref: ref.iref, name: ref.name, sku: ref.sku } } : { product: id };
      }
      const idCands = [
        it?.product?.iref, it?.productRef?.iref,
        it?.product, it?.product_id, it?.productId, it?.productID,
        it?.product_iref, it?.productIref, it?.p_id, it?.p_iref,
        it?.sku, it?.code
      ].filter(Boolean).map(String);
      let ref = null;
      for (const id of idCands) { ref = pIdx.get(id); if (ref) break; }
      return (ref && (!it.product && !it.productRef))
        ? { ...it, productRef: { iref: ref.iref, name: ref.name, sku: ref.sku } }
        : it;
    });
    const fixC = (arr) => this.arrayizeComboList(arr).map(it => {
      if (typeof it === 'string' || typeof it === 'number') {
        const id = String(it);
        const ref = cIdx.get(id);
        return ref ? { comboRef: { iref: ref.iref, name: ref.name, sku: ref.sku } } : { productCombo: id };
      }
      const idCands = [
        it?.productCombo?.iref, it?.comboRef?.iref,
        it?.productCombo, it?.combo_id, it?.comboId, it?.comboID,
        it?.combo_iref, it?.comboIref, it?.c_id, it?.c_iref,
        it?.sku, it?.code
      ].filter(Boolean).map(String);
      let ref = null;
      for (const id of idCands) { ref = cIdx.get(id); if (ref) break; }
      return (ref && (!it.productCombo && !it.comboRef))
        ? { ...it, comboRef: { iref: ref.iref, name: ref.name, sku: ref.sku } }
        : it;
    });

    return {
      ...detail,
      productCompany_list: fixP(detail.productCompany_list),
      comboCompany_list: fixC(detail.comboCompany_list),
    };
  };

  ensureDetailItems = (iref, attempt = 0) => {
    const d = this.state.readDetail;
    const hasLines =
      (Array.isArray(d?.productCompany_list) && d.productCompany_list.length) ||
      (Array.isArray(d?.comboCompany_list) && d.comboCompany_list.length);
    const haveNames  = this.hasHydratedItems(d);
    const havePrice  = this.hasUsablePrices(d);
    if ((hasLines && haveNames && havePrice) || attempt >= 5) return;

    setTimeout(() => {
      const fresh = this.fetchDetailByIref(iref);
      const hydratedFresh = this.hydrateDetailWithCatalogs(fresh);
      const enriched = enrichCompanyCounts(hydratedFresh);
      this.setState({
        readDetail: enriched,
        metaDateFrom: enriched.dateFrom || '',
        metaDateTo:   enriched.dateTo || '',
        metaIsActive: !!enriched.isActive,
        metaDescription: enriched.description || '',
        metaCurrency: toCurrencyName(enriched.currency),
        metaWithVAT:  !!enriched.withVAT,
        metaCreatedOn: enriched.createdOn || '',
        metaShortName: enriched.shortName || '',
      }, () => this.ensureDetailItems(iref, attempt + 1));
    }, Math.min(250 + attempt * 250, 1500));
  };

  openRead = (row, opts = {}) => {
    const forceHydrate = !!opts.forceHydrate;
    const key = row?.iref || row?.id || row?.pk;
    if (!key) return;
  
    // Decide if we must fetch a full detail
    let base = row;
    const hasAnyItems =
      !!base && (
        (base.productCompany_list && (Array.isArray(base.productCompany_list) ? base.productCompany_list.length : Object.keys(base.productCompany_list||{}).length)) ||
        (base.comboCompany_list && (Array.isArray(base.comboCompany_list) ? base.comboCompany_list.length : Object.keys(base.comboCompany_list||{}).length))
      );
    const needHydration = forceHydrate || !hasAnyItems || !this.hasHydratedItems(base);
  
    // Show dialog in loading state, render rows only after hydration
    this.setState({ readOpen: true, readLoading: true, readDetail: null }, () => {
      let detail = base;
      if (needHydration) {
        const fresh = this.fetchDetailByIref(key);
        if (fresh) detail = fresh;
      }
      // client-side enrichment from catalogs (covers ID-only rows)
      detail = this.hydrateDetailWithCatalogs(detail);
      const enriched = enrichCompanyCounts(detail);
      // Populate meta fields too (keeps header chips/selects in sync)
      this.setState({
        readDetail: enriched,
        readLoading: false,
        metaDateFrom: enriched.dateFrom || '',
        metaDateTo:   enriched.dateTo || '',
        metaIsActive: !!enriched.isActive,
        metaDescription: enriched.description || '',
        metaCurrency: toCurrencyName(enriched.currency),
        metaWithVAT:  !!enriched.withVAT,
        metaCreatedOn: enriched.createdOn || '',
        metaShortName: enriched.shortName || '',
        metaCompany: (enriched.company?.iref || enriched.company || '')
      }, () => this.ensureDetailItems(key)); 
    });
  }

  handleAttemptCloseRead = () => {
    const hasItemEdits =
      Object.keys(this.state.readEdits.products || {}).length ||
      Object.keys(this.state.readEdits.combos || {}).length ||
      (this.state.readAdds.products?.length) ||
      (this.state.readAdds.combos?.length) ||
      (this.state.readRemovals.products?.size) ||
      (this.state.readRemovals.combos?.size);

    const hasMetaEdits = !!this.state.metaDirty;

    if (hasItemEdits || hasMetaEdits) {
      this.setState({ confirmCloseOpen: true }); // reuse your confirm dialog
    } else {
      this.setState({ readOpen: false });
    }
  };

  // ----- METADATA SAVE (no new version) -----
  saveMeta = (closeAfter=false) => {
    const d = this.state.readDetail;
    if (!d || !this.state.metaDirty) return;

    // 1) Identify the list by iref (required by the new endpoint)
    const iref = String(d.iref || '');
    if (!iref) {
      this.setState({ snack:{ open:true, message:'Missing iref for meta update.', severity:'error' } });
      return;
    }

    // 2) Build a backend-friendly payload
    //    - currency: numeric code -> string ("0","1","2"), keeps 0 (RON)
    //    - withVAT, isActive: 0/1 (works with your _parse_bool)
    const body = {
      iref,
      dateFrom: this.state.metaDateFrom ?? d.dateFrom ?? '',
      dateTo:   this.state.metaDateTo   ?? d.dateTo   ?? '',
      isActive: this.state.metaIsActive ? 1 : 0,
      description: this.state.metaDescription ?? (d.description || ''),
    };
    if (this.state.metaCompany && this.state.metaCompany !== (d.company?.iref || d.company)) {
      body.company = String(this.state.metaCompany);
    }

    if (this.state.metaCurrency !== undefined && this.state.metaCurrency !== null && this.state.metaCurrency !== '') {
      const code = toCurrencyCode(this.state.metaCurrency);
      if (Number.isInteger(code)) body.currency = String(code);
    }
    if (this.state.metaWithVAT === true || this.state.metaWithVAT === false) {
      body.withVAT = this.state.metaWithVAT ? 1 : 0;
    }

    // 3) POST (make sure your Client doesn't auto-append filter query params here)
    let res = null;
    try {
      res = this.state.client.pushData(UPDATE_META_ENDPOINT(), body);
    } catch (e) { res = null; }

    if (!res || res.status === 'error' || res.detail) {
      this.setState({ snack: { open:true, message: (res?.detail || 'Meta update failed.'), severity:'error' } });
      return;
    }

    // 4) Merge into UI so changes are visible immediately
    const merged = {
      ...d,
      dateFrom: body.dateFrom,
      dateTo:   body.dateTo,
      isActive: !!body.isActive,
      description: body.description,
      currency: body.currency != null ? Number(body.currency) : d.currency,
      withVAT:  (body.withVAT != null ? !!body.withVAT : d.withVAT),
      company: body.company ? { ...(d.company || {}), iref: body.company, name: this.state.companies?.[String(body.company)]?.name } : d.company,
      shortName: this.computeShortName(body.company || (d.company?.iref || d.company)),
    };
    this.setState({
      readDetail: merged,
      metaDateFrom: merged.dateFrom,
      metaDateTo:   merged.dateTo,
      metaCompany: (merged.company?.iref || merged.company || ''),
      metaIsActive: !!merged.isActive,
      metaDescription: merged.description,
      metaCurrency: toCurrencyName(merged.currency),
      metaWithVAT:  !!merged.withVAT,
      metaCreatedOn: merged.createdOn,
      metaShortName: merged.shortName || '',
      metaDirty:false, editPriceList:false,
      snack: { open:true, message:'Updated.', severity:'success' },
      readOpen: (closeAfter ? false : this.state.readOpen),
    }, () => {
      // keep list row in sync with current filters
      this.fetchLatest(this.buildQueryFromFilters());
    });
  };

  // ---- item edit helpers ----
  setEdit = (bucket, key, field, value) => {
    this.setState((prev)=>{
      const edits = { ...prev.readEdits };
      const obj = { ...(edits[bucket][key] || {}) };
      obj[field] = value;
      edits[bucket] = { ...edits[bucket], [key]: obj };
      return { readEdits: edits };
    });
  };
  toggleRemoval = (bucket, key) => {
    this.setState((prev)=>{
      const s = new Set(prev.readRemovals[bucket]);
      if (s.has(key)) s.delete(key); else s.add(key);
      return { readRemovals: { ...prev.readRemovals, [bucket]: s } };
    });
  };
  removeNewRow = (bucket, tempIndex) => {
    this.setState((prev)=>{
      const arr = [...prev.readAdds[bucket]];
      arr.splice(tempIndex,1);
      return { readAdds: { ...prev.readAdds, [bucket]: arr } };
    });
  };

  // ---- preloaded add ----
  filterProducts = (q) => {
    const src = (this.state.allProducts || []).filter(p => p.isForSale);
    if (!q) return src.slice(0,50);
    const qq = q.toLowerCase();
    return src.filter(o =>
      (o.name && o.name.toLowerCase().includes(qq)) ||
      (o.sku && o.sku.toLowerCase().includes(qq)) ||
      (o.iref && String(o.iref).toLowerCase().includes(qq))
    ).slice(0,50);
  };
  filterCombos = (q) => {
    const src = this.state.allCombos;
    if (!q) return src.slice(0,50);
    const qq = q.toLowerCase();
    return src.filter(o =>
      (o.name && o.name.toLowerCase().includes(qq)) ||
      (o.sku && o.sku.toLowerCase().includes(qq)) ||
      (o.iref && String(o.iref).toLowerCase().includes(qq))
    ).slice(0,50);
  };
  matchesAddQuery = (item, q) => {
    const qq = String(q || '').trim().toLowerCase();
    if (!qq) return true;
    return (
      String(item?.name || '').toLowerCase().includes(qq) ||
      String(item?.sku || '').toLowerCase().includes(qq) ||
      String(item?.iref || '').toLowerCase().includes(qq) ||
      String(item?.product_iref || '').toLowerCase().includes(qq) ||
      String(item?.combo_iref || '').toLowerCase().includes(qq) ||
      String(item?.product_name || '').toLowerCase().includes(qq) ||
      String(item?.combo_name || '').toLowerCase().includes(qq)
    );
  };
  productIdOf = (it) => (
    it?.product?.iref ||
    it?.productRef?.iref ||
    it?.product ||
    it?.product_id ||
    it?.product_iref ||
    it?.productId ||
    it?.productID ||
    it?.productIref ||
    null
  );
  comboIdOf = (it) => (
    it?.productCombo?.iref ||
    it?.comboRef?.iref ||
    it?.productCombo ||
    it?.combo_id ||
    it?.combo_iref ||
    it?.comboId ||
    it?.comboID ||
    it?.comboIref ||
    null
  );
  existsInCurrent = (iref, isCombo=false) => {
    const detail = this.state.readDetail;
    if (!detail || !iref) return false;
    if (!isCombo) {
      const found = this.companyProductsOf(detail).some((it, idx) => {
        const item = this.normalizeProductItem(it, detail, idx);
        return String(this.productIdOf(item)) === String(iref);
      });
      const inAdds = (this.state.readAdds.products || []).some(n =>
        String(n.product_iref) === String(iref)
      );

      return found || inAdds;
    }
    const found = this.companyCombosOf(detail).some((it, idx) => {
      const item = this.normalizeComboItem(it, detail, idx);
      return String(this.comboIdOf(item)) === String(iref);
    });
    const inAdds = (this.state.readAdds.combos || []).some(n =>
      String(n.combo_iref) === String(iref)
    );
    return found || inAdds;
  };
  addNewProduct = () => {
    const s = this.state.prodSelected;
    const price = this.state.prodPriceInput;
    if (!s || !s.iref || price === '' || isNaN(Number(price)) || Number(price) < 0) {
      this.setState({ snack:{ open:true, message:'Select a product and enter a numeric price.', severity:'warning' } });
      return;
    }
    if (this.existsInCurrent(s.iref, false)) {
      this.setState({ snack:{ open:true, message:'Product already in this list.', severity:'info' } });
      return;
    }
    this.setState((prev)=> ({
      readAdds: {
        ...prev.readAdds,
        products: [
          ...prev.readAdds.products,
          {
            product_iref: s.iref,
            product_name: s.name,
            price: Number(price),
            isActive: !!prev.prodActiveInput,
            isForSale: s.isForSale,
            status: this.STATUS_LABELS[s.status] ?? '—',
          }
        ],
      },
      prodSelected: null,
      prodAddQuery: '',
      prodPriceInput: '',
      prodOptions: prev.allProducts.slice(0,50),
    }));
  };
  addNewCombo = () => {
    const s = this.state.comboSelected;
    const price = this.state.comboPriceInput;
    if (!s || !s.iref || price === '' || isNaN(Number(price)) || Number(price) < 0) {
      this.setState({ snack:{ open:true, message:'Select a combo and enter a numeric price.', severity:'warning' } });
      return;
    }
    if (this.existsInCurrent(s.iref, true)) {
      this.setState({ snack:{ open:true, message:'Combo already in this list.', severity:'info' } });
      return;
    }
    this.setState((prev)=> ({
      readAdds: {
        ...prev.readAdds,
        combos: [
          ...prev.readAdds.combos,
          {
            combo_iref: s.iref,
            combo_name: s.name,
            price: Number(price),
            isActive: !!prev.comboActiveInput,
            isForSale: s.isForSale,
            status: this.STATUS_LABELS[s.status] ?? '—',
          }
        ],
      },
      comboSelected: null,
      comboAddQuery: '',
      comboPriceInput: '',
      comboOptions: prev.allCombos.slice(0,50),
    }));
  };

  getThumbFromImages = (imgList) => {
    try {
      if (!imgList || !imgList.length) return null;
      let src = imgList[0]?.image;
      for (let i = 0; i < imgList.length; i++) {
        if (imgList[i]?.isMain === true) { src = imgList[i].image; break; }
      }
      if (!src) return null;
      const fileName = src.replace(/\.[^/.]+$/, "");
      const ext = src.split(".").pop();
      return `${fileName}_s.${ext}`;
    } catch(e) { return null; }
  };

  // ---- save new version (items diff) ----
  saveNewVersionFromEdits = (closeAfter = false) => {
    this.setState({ savingItems: true, closeAfterSave: closeAfter });

    const { readDetail, readEdits, readAdds, readRemovals, qFilters } = this.state;
    if (!readDetail) return;

    // ----- PRODUCTS: edits/removals -----
    const prodChanges = [];
    this.companyProductsOf(readDetail).forEach((it, idx) => {
      const key = this.makeProdKey(it, idx);
      const chg = readEdits.products[key];

      // REQUIRE a real product iref; don't fall back to sku/key
      const prodIref = it.product?.iref || it.productRef?.iref;
      if (!prodIref) return;

      if (this.state.readRemovals.products.has(key)) {
        prodChanges.push({ product_iref: prodIref, remove: true });
        return;
      }
      if (!chg) return;

      const payload = { product_iref: prodIref };
      if (chg.price != null && chg.price !== '' && !Number.isNaN(Number(chg.price))) {
        payload.price = Math.max(0, Number(chg.price));
      }
      if (chg.isActive != null) payload.isActive = !!chg.isActive;

      if (payload.price !== undefined || payload.isActive !== undefined) {
        prodChanges.push(payload);
      }
    });

    // ----- COMBOS: edits/removals -----
    const comboChanges = [];
    this.companyCombosOf(readDetail).forEach((it, idx) => {
      const key = this.makeComboKey(it, idx);
      const chg = readEdits.combos[key];

      const comboIref = it.productCombo?.iref || it.comboRef?.iref;
      if (!comboIref) return;

      if (this.state.readRemovals.combos.has(key)) {
        comboChanges.push({ combo_iref: comboIref, remove: true });
        return;
      }
      if (!chg) return;

      const payload = { combo_iref: comboIref };
      if (chg.price != null && chg.price !== '' && !Number.isNaN(Number(chg.price))) {
        payload.price = Math.max(0, Number(chg.price));
      }
      if (chg.isActive != null) payload.isActive = !!chg.isActive;

      if (payload.price !== undefined || payload.isActive !== undefined) {
        comboChanges.push(payload);
      }
    });

    // ----- NEW: PRODUCTS additions -----
    (readAdds.products || []).forEach(n => {
      const prodIref = n?.product_iref || n?.iref;
      if (!prodIref) return;

      const payload = { product_iref: prodIref, add: true };
      if (n.price != null && n.price !== '' && !Number.isNaN(Number(n.price))) {
        payload.price = Math.max(0, Number(n.price));
      }
      if (n.isActive != null) payload.isActive = !!n.isActive;
      prodChanges.push(payload);
    });

    // COMBOS additions (guard NaN)
    (readAdds.combos || []).forEach(n => {
      const comboIref = n?.combo_iref || n?.iref;
      if (!comboIref) return;

      const payload = { combo_iref: comboIref, add: true };
      if (n.price != null && n.price !== '' && !Number.isNaN(Number(n.price))) {
        payload.price = Math.max(0, Number(n.price));
      }
      if (n.isActive != null) payload.isActive = !!n.isActive;
      comboChanges.push(payload);
    });

    // If nothing to do, bail early
    if (prodChanges.length === 0 && comboChanges.length === 0) {
      this.setState({
        savingItems: false,
        snack: { open: true, message: 'No changes to save.', severity: 'info' }
      });
      return;
    }

    /* eslint-disable camelcase */
    const payload = {
      from_location_id: readDetail.location?.iref || readDetail.location,
      company: (readDetail.company?.iref || readDetail.company),
      from_companyList_version: Number(readDetail.version),
      currency: (typeof toCurrencyCode === 'function' ? toCurrencyCode(readDetail.currency) : readDetail.currency),
      withVAT: !!readDetail.withVAT,
      product_changes: prodChanges,
      combo_changes: comboChanges,
    };
    /* eslint-enable camelcase */

    let res = null;
    try {
      res = this.state.client.pushData(`${Config.API_URL_LIST_COMPANY}new_version/`, payload);
    } catch (e) { res = null; }

    if (!res || res.status === 'error' || res.detail) {
      this.setState({ savingItems: false, snack: { open: true, message: 'Could not save via API. Exported changes JSON.', severity: 'warning' } });
      downloadBlob(JSON.stringify(payload, null, 2), `companyList_changes_${todayISO()}.json`, 'application/json');
      return;
    }

    const wasMaterialized = (res.mode === 'materialized');
    const msg = res?.message || (wasMaterialized ? 'Saved items.' : 'New version created');

    // Reset edit buffers
    this.setState({
      snack: { open: true, message: msg, severity: 'success' },
      readEditMode: false,
      readEdits: { products: {}, combos: {} },
      readAdds: { products: [], combos: [] },
      readRemovals: { products: new Set(), combos: new Set() }
    });

    const track = {
      location: qFilters.location || (readDetail.location?.iref || readDetail.location),
      company: qFilters.company || (readDetail.company?.iref || readDetail.company),
      currency: (typeof toCurrencyCode === 'function' ? toCurrencyCode(readDetail.currency) : readDetail.currency),
      withVAT: !!readDetail.withVAT
    };
    const newIref = res.iref;

    // Refresh meta for the track (thin list)
    this.fetchLatest({ ...track, all_versions: 1 });

    if (closeAfter) {
      this.setState({
        savingItems: false,
        readOpen: false,
        closeAfterSave: false,
      });
      return;
    }

    // Otherwise keep dialog open on the new version (force full fetch + hydrate)
    let detail = null;
    try { detail = this.state.client.getData(`${Config.API_URL_LIST_COMPANY}${newIref}/`, {}); }
    catch (e) { detail = null; }
    if (detail) {
      this.openRead(detail, { forceHydrate: true });
    } else {
      const cur = this.getDetailByIref(newIref);
      if (cur) this.openRead(cur, { forceHydrate: true });
    }

    this.setState({
      savingItems: false,
      // readOpen stays true in this branch
      closeAfterSave: false,
    });
  };

  // ---- create empty price list (from filters + "+") ----
  handleCreateEmpty = (payload) => {
    // normalize currency and booleans
    const body = {
      ...payload,
      company: payload.company,     // << required
      currency: toCurrencyCode(payload.currency),
      withVAT: !!payload.withVAT,
      isActive: !!payload.isActive
    };
    let res = null;
    try { res = this.state.client.pushData(CREATE_EMPTY_ENDPOINT(), body); }
    catch (e) { res = null; }
    if (!res || res.status === 'error' || res.detail) {
      this.setState({ snack:{ open:true, message:'Could not create via API. Exported JSON.', severity:'warning' } });
      downloadBlob(JSON.stringify(body, null, 2), `pricelist_new_${todayISO()}.json`, 'application/json');
      return;
    }
    this.setState({ snack:{ open:true, message: res?.message || 'Price list created.', severity:'success' } });
    // Show the new draft immediately: fetch the whole track, no status filter
    const newIref = res?.iref || res?.data?.iref;
    const loc = payload.location;
    const cur = payload.currency;   // normalize if needed with toCurrencyCode(...)
    const vat = !!payload.withVAT;
    const comp = payload.company;
    this.setState(prev => ({ qFilters: { ...prev.qFilters, company: comp, location: loc, currency: cur, withVAT: vat } }));
    this.fetchLatest({ company: comp, location: loc, currency: cur, withVAT: vat, all_versions: 1 });
    // Optionally open it
    if (newIref) {
      const detail = this.getDetailByIref(newIref);
      if (detail) this.openRead(detail);
    }
  };

  // ---- CSV import for empty/new company list versions ----
  getExistingCompanyItemCount = (detail = this.state.readDetail) => {
    if (!detail) return 0;

    const arrLen = (v) => {
      if (Array.isArray(v)) return v.length;
      if (v && typeof v === 'object') return Object.keys(v).length;
      return 0;
    };

    const productsLen = arrLen(detail.productCompany_list);
    const combosLen = arrLen(detail.comboCompany_list);
    const hydratedCount = productsLen + combosLen;

    const countFields = [
      detail._prodCount,
      detail._comboCount,
      detail.productCount,
      detail.comboCount,
      detail.productsCount,
      detail.combosCount,
    ];

    const metaCount = countFields.reduce((sum, v) => {
      const n = Number(v);
      return Number.isFinite(n) ? sum + n : sum;
    }, 0);

    return Math.max(hydratedCount, metaCount);
  };

  canImportCompanyCsv = () => {
    const d = this.state.readDetail;
    if (!d || !d.iref) return false;

    const pendingAdds =
      (this.state.readAdds?.products || []).length +
      (this.state.readAdds?.combos || []).length;

    return this.getExistingCompanyItemCount(d) === 0 && pendingAdds === 0;
  };

  parseCsvLine = (line) => {
    const out = [];
    let cur = '';
    let inQuotes = false;

    for (let i = 0; i < line.length; i += 1) {
      const ch = line[i];
      const next = line[i + 1];

      if (ch === '"' && inQuotes && next === '"') {
        cur += '"';
        i += 1;
      } else if (ch === '"') {
        inQuotes = !inQuotes;
      } else if (ch === ',' && !inQuotes) {
        out.push(cur.trim());
        cur = '';
      } else {
        cur += ch;
      }
    }

    out.push(cur.trim());
    return out;
  };

  parseCompanyImportCsv = (text) => {
    const lines = String(text || '')
      .replace(/^\uFEFF/, '')
      .split(/\r?\n/)
      .map(l => l.trim())
      .filter(Boolean);

    if (!lines.length) return { rows: [], errors: ['CSV file is empty.'] };

    const header = this.parseCsvLine(lines[0]).map(h => h.toLowerCase());
    const typeIdx = header.indexOf('type');
    const irefIdx = header.indexOf('iref');
    const priceIdx = header.indexOf('price');

    if (typeIdx < 0 || irefIdx < 0 || priceIdx < 0) {
      return { rows: [], errors: ['CSV header must contain: type, iref, price.'] };
    }

    const rows = [];
    const errors = [];
    const seen = new Set();

    lines.slice(1).forEach((line, idx) => {
      const lineNo = idx + 2;
      const cols = this.parseCsvLine(line);
      const type = String(cols[typeIdx] || '').trim().toLowerCase();
      const iref = String(cols[irefIdx] || '').trim();
      const rawPrice = String(cols[priceIdx] || '').trim().replace(',', '.');
      const price = Number(rawPrice);
      const key = `${type}:${iref}`;

      if (!['product', 'combo'].includes(type)) {
        errors.push(`Line ${lineNo}: type must be product or combo.`);
        return;
      }

      if (!iref) {
        errors.push(`Line ${lineNo}: missing iref.`);
        return;
      }

      if (rawPrice === '' || !Number.isFinite(price) || price < 0) {
        errors.push(`Line ${lineNo}: invalid price.`);
        return;
      }

      if (seen.has(key)) {
        errors.push(`Line ${lineNo}: duplicate ${type} ${iref}.`);
        return;
      }

      seen.add(key);
      rows.push({ type, iref, price });
    });

    return { rows, errors };
  };

  downloadCompanyImportTemplate = () => {
    const sample = [
      'type,iref,price',
      'product,PRODUCT_IREF_HERE,19.90',
      'combo,COMBO_IREF_HERE,34.50',
    ].join('\n');

    downloadBlob(
      sample,
      `company_list_import_template_${todayISO()}.csv`,
      'text/csv;charset=utf-8;'
    );
  };

  handleCompanyCsvSelected = (e) => {
    const file = e?.target?.files?.[0];
    if (e?.target) e.target.value = '';
    if (!file) return;

    if (!this.canImportCompanyCsv()) {
      this.setState({
        snack: {
          open: true,
          message: 'CSV import is available only for empty company list versions.',
          severity: 'warning'
        }
      });
      return;
    }

    this.setState({ csvImporting: true });

    const reader = new FileReader();

    reader.onload = () => {
      const { rows, errors } = this.parseCompanyImportCsv(reader.result || '');

      const productsByIref = new Map(
        (this.state.allProducts || []).map(p => [String(p.iref), p])
      );

      const combosByIref = new Map(
        (this.state.allCombos || []).map(c => [String(c.iref), c])
      );

      const productAdds = [];
      const comboAdds = [];
      const validationErrors = [...errors];

      rows.forEach((row) => {
        if (row.type === 'product') {
          const product = productsByIref.get(String(row.iref));

          if (!product) {
            validationErrors.push(`Product not found: ${row.iref}`);
            return;
          }

          productAdds.push({
            product_iref: product.iref,
            product_name: product.name,
            price: row.price,
            isActive: true,
            isForSale: product.isForSale,
            status: this.STATUS_LABELS[product.status] ?? '—',
          });
        } else if (row.type === 'combo') {
          const combo = combosByIref.get(String(row.iref));

          if (!combo) {
            validationErrors.push(`Combo not found: ${row.iref}`);
            return;
          }

          comboAdds.push({
            combo_iref: combo.iref,
            combo_name: combo.name,
            price: row.price,
            isActive: true,
            isForSale: combo.isForSale,
            status: this.STATUS_LABELS[combo.status] ?? '—',
          });
        }
      });

      if (validationErrors.length) {
        const body = validationErrors
          .map(x => `"${String(x).replace(/"/g, '""')}"`)
          .join('\n');

        downloadBlob(
          `error\n${body}`,
          `company_list_import_errors_${todayISO()}.csv`,
          'text/csv;charset=utf-8;'
        );

        this.setState({
          csvImporting: false,
          snack: {
            open: true,
            message: 'CSV import has errors. An error file was downloaded.',
            severity: 'error'
          }
        });

        return;
      }

      if (!productAdds.length && !comboAdds.length) {
        this.setState({
          csvImporting: false,
          snack: {
            open: true,
            message: 'No valid rows found in CSV.',
            severity: 'warning'
          }
        });

        return;
      }

      this.setState((prev) => ({
        csvImporting: false,
        readEditMode: true,
        readAdds: {
          ...prev.readAdds,
          products: [...(prev.readAdds.products || []), ...productAdds],
          combos: [...(prev.readAdds.combos || []), ...comboAdds],
        },
        snack: {
          open: true,
          message: `Imported ${productAdds.length} products and ${comboAdds.length} combos. Review and save items to apply.`,
          severity: 'success'
        }
      }));
    };

    reader.onerror = () => {
      this.setState({
        csvImporting: false,
        snack: {
          open: true,
          message: 'Could not read CSV file.',
          severity: 'error'
        }
      });
    };

    reader.readAsText(file);
  };

  exportCompanyDetailCSV = () => {
    const detail = this.state.readDetail;
    return sharedExportDetailCSV(detail, {
      companyProductsOf: (d) => this.companyProductsOf(d),
      companyCombosOf: (d) => this.companyCombosOf(d),
      normalizeProductItem: (it, d, i) => this.normalizeProductItem(it, d, i),
      normalizeComboItem: (it, d, i) => this.normalizeComboItem(it, d, i),
      toCurrencyName,
      csvCell,
      downloadBlob,
      todayISO,
    });
  };

  exportCompanyLatestCSV = (row = null) => {
    const lists = row?.iref
      ? [row]
      : (this.state.lists || []);

    if (!lists.length) return;

    // Make sure catalogs are in memory so normalization can fill names/sku
    if (!this.state.allProducts?.length || !this.state.allCombos?.length) {
      this.preloadCatalogs?.();
    }

    const helpers = {
      getDetailByIref: (id) => this.getDetailByIref(id),
      hydrateDetailWithCatalogs: (d) => this.hydrateDetailWithCatalogs(d),
      companyProductsOf: (d) => this.companyProductsOf(d),
      companyCombosOf: (d) => this.companyCombosOf(d),
      normalizeProductItem: (it, d, i) => this.normalizeProductItem(it, d, i),
      normalizeComboItem: (it, d, i) => this.normalizeComboItem(it, d, i),
    };

    // Always export WITH details
    sharedExportLatestCSV(lists, helpers, { withDetails: true });
  };

  // ============== COMPARE (brought back from v1) ==============
  getHydratedDetailForCompare = async (rowOrIref) => {
    const id = (typeof rowOrIref === 'string' || typeof rowOrIref === 'number')
      ? String(rowOrIref)
      : (rowOrIref?.iref || rowOrIref?.id || '');
    if (!id) return rowOrIref;
    // ensure catalogs (for name/sku fill-in)
    if (!this.state.allProducts?.length || !this.state.allCombos?.length) {
      this.preloadCatalogs?.();
    }
    // single fetch hydrate
    const raw = this.getDetailByIref(id) || rowOrIref;
    return this.hydrateDetailWithCatalogs(raw);
  };

  buildNameIndex = (details) => {
    const prod = new Map();
    const comb = new Map();
    (details || []).forEach((d) => {
      (this.companyProductsOf(d) || []).forEach((row, i) => {
        const it = this.normalizeProductItem(row, d, i);
        const id = it?.product?.iref || it?.productRef?.iref || it?.sku;
        if (id) prod.set(String(id), { name: it.name, sku: it.sku });
      });
      (this.companyCombosOf(d) || []).forEach((row, i) => {
        const it = this.normalizeComboItem(row, d, i);
        const id = it?.productCombo?.iref || it?.comboRef?.iref || it?.sku;
        if (id) comb.set(String(id), { name: it.name, sku: it.sku });
      });
    });
    return { prod, comb };
  };

  displayName = (r) => {
    // 1) direct fields from normalized or nested
    const direct =
      r?.name ||
      r?.product?.name || r?.productRef?.name ||
      r?.productCombo?.name || r?.comboRef?.name;
    if (direct) return direct;
  
    // 2) try catalog lookup by any candidate id
    const ids = [
      r?.product?.iref, r?.productRef?.iref, r?.product, r?.product_id, r?.productID, r?.productIref, r?.product_iref, r?.p_id, r?.p_iref,
      r?.productCombo?.iref, r?.comboRef?.iref, r?.productCombo, r?.combo_id, r?.comboID, r?.comboIref, r?.combo_iref, r?.c_id, r?.c_iref,
      r?.sku, r?.code
    ].filter(Boolean).map(String);

    // ✅ FIRST try the small compare index built from the two details
    const fromIdx = (id) => {
      const s = String(id);
      const hit = this.state.cmpIdx?.prod?.get(s) || this.state.cmpIdx?.comb?.get(s);
      return hit?.name || null;
    };
    for (const id of ids) { const v = fromIdx(id); if (v) return v; }
    
    for (const id of ids) {
      const p = (this.state.allProducts || []).find(x =>
        String(x.iref) === id || String(x.id) === id || String(x.sku) === id || String(x.code) === id || String(x.uuid) === id
      );
      if (p?.name) return p.name;
      const c = (this.state.allCombos || []).find(x =>
        String(x.iref) === id || String(x.id) === id || String(x.sku) === id || String(x.code) === id || String(x.uuid) === id
      );
      if (c?.name) return c.name;
    }
    // 2.5) compare index (built from the two details)
    const checkIdx = (id) => {
      const s = String(id);
      const hit = this.state.cmpIdx?.prod?.get(s) || this.state.cmpIdx?.comb?.get(s);
      return hit?.name || null;
    };
    for (const id of ids) { const v = checkIdx(id); if (v) return v; }
    // 3) fallback to sku/ids
    const idish =
      r?.sku ||
      r?.product?.iref || r?.productRef?.iref ||
      r?.productCombo?.iref || r?.comboRef?.iref;
    if (idish) return String(idish);
    
    // 4) FINAL fallback: the stable key we used in the diff
    const key =
      (typeof this.stableProdKey === 'function' ? this.stableProdKey(r) : '') ||
      (typeof this.stableComboKey === 'function' ? this.stableComboKey(r) : '') ||
      r?._idKey;
    return key ? String(key) : '—';
  };

  nameOf = (val, listOrMap) =>
    typeof val === 'object'
      ? (val?.name || '—')
      : Array.isArray(listOrMap)
        ? (listOrMap.find(x => String(x.iref) === String(val))?.name || String(val))
        : (listOrMap?.[String(val)]?.name || String(val) || '—');
  
  displaySku = (r) => {
    const direct =
      r?.sku ||
      r?.product?.sku || r?.productRef?.sku ||
      r?.productCombo?.sku || r?.comboRef?.sku;
    if (direct) return direct;
    const ids = [
      r?.product?.iref, r?.productRef?.iref, r?.product, r?.product_id, r?.productID, r?.productIref, r?.product_iref, r?.p_id, r?.p_iref,
      r?.productCombo?.iref, r?.comboRef?.iref, r?.productCombo, r?.combo_id, r?.comboID, r?.comboIref, r?.combo_iref, r?.c_id, r?.c_iref,
      r?.code
    ].filter(Boolean).map(String);
    for (const id of ids) {
      const p = (this.state.allProducts || []).find(x =>
        String(x.iref) === id || String(x.id) === id || String(x.code) === id || String(x.uuid) === id
      );
      if (p?.sku) return p.sku;
      const c = (this.state.allCombos || []).find(x =>
        String(x.iref) === id || String(x.id) === id || String(x.code) === id || String(x.uuid) === id
      );
      if (c?.sku) return c.sku;
    }
    const checkIdx = (id) => {
      const s = String(id);
      const hit = this.state.cmpIdx?.prod?.get(s) || this.state.cmpIdx?.comb?.get(s);
      return hit?.sku || null;
    };
    for (const id of ids) { const v = checkIdx(id); if (v) return v; }
    // Fall back to the stable key if nothing else
    const key =
      (typeof this.stableProdKey === 'function' ? this.stableProdKey(r) : '') ||
      (typeof this.stableComboKey === 'function' ? this.stableComboKey(r) : '') ||
      r?._idKey;
    return key ? String(key) : '';
  };
  parsePrice = (v) => {
    if (v === null || v === undefined) return undefined;
    if (typeof v === 'number' && Number.isFinite(v)) return v;
    const s = String(v).trim().replace(/\s+/g,'').replace(',', '.');
    const n = Number(s);
    return Number.isFinite(n) ? n : undefined;
  };
    parseVersion = (v) => {
    if (typeof v === 'number') return v;
    const m = String(v || '').match(/\d+/);
    return m ? Number(m[0]) : NaN;
  };

  buildDiff(base, other){
    const bP = this.arrayizeProductList(base?.productCompany_list).map((it, i) => this.normalizeProductItem(it, base, i));
    const oP = this.arrayizeProductList(other?.productCompany_list).map((it, i) => this.normalizeProductItem(it, other, i));
    const bC = this.arrayizeComboList(base?.comboCompany_list ).map((it, i) => this.normalizeComboItem(it, base, i));
    const oC = this.arrayizeComboList(other?.comboCompany_list).map((it, i) => this.normalizeComboItem(it, other, i));

    const diffItems = (A, B, stableKey) => {
      const aMap = new Map(A.map(x => [stableKey(x), x]));
      const bMap = new Map(B.map(x => [stableKey(x), x]));
      const keys = new Set([...aMap.keys(), ...bMap.keys()]);
      const added = [], removed = [], changed = [];

      keys.forEach(k => {
        const x = aMap.get(k); // base (current)
        const y = bMap.get(k); // other (previous)
        if (x && !y) { added.push({ ...x, _idKey: k }); return; }
        if (!x && y) { removed.push({ ...y, _idKey: k }); return; }
        if (x && y) {
          const px = (x?.price == null ? null : this.parsePrice(x.price));
          const py = (y?.price == null ? null : this.parsePrice(y.price));
          const ax = !!x.isActive;
          const ay = !!y.isActive;
          const cx = String(x.currency ?? base?.currency ?? '');
          const cy = String(y.currency ?? other?.currency ?? '');
          const vx = String(x.vatId ?? '');
          const vy = String(y.vatId ?? '');
          if (px !== py || ax !== ay || cx !== cy || vx !== vy) {
            changed.push({
              _idKey: k,
              from: { name: y.name, sku: y.sku, price: py, isActive: ay, currency: cy, vatId: vy },
              to:   { name: x.name, sku: x.sku, price: px, isActive: ax, currency: cx, vatId: vx }
            });
          }
        }
      });

      return {
        summary: { added: added.length, removed: removed.length, changed: changed.length, total: added.length + removed.length + changed.length },
        added, removed, changed
      };
    };

    return {
      products: diffItems(bP, oP, this.stableProdKey),
      combos:   diffItems(bC, oC, this.stableComboKey),
    };
  };

  ensureCatalogsReady = async () => {
    if (this.state.allProducts?.length && this.state.allCombos?.length) return;
    // kick a preload if needed
    this.preloadCatalogs?.();
    // wait briefly for state to populate (Client.getData is sync in your app)
    for (let i = 0; i < 5; i++) {
      if (this.state.allProducts?.length && this.state.allCombos?.length) return;
      // eslint-disable-next-line no-await-in-loop
      await new Promise(res => setTimeout(res, 150));
    }
  };

  // Lightweight, hydrated Compare (single definition)
  openComparePrev = async (row) => {
    if (!row) return;
    await this.ensureCatalogsReady();

    // Track identity
    const loc = row.location?.iref || row.location;
    const cur = (Number.isInteger(row.currency) ? row.currency : toCurrencyCode(row.currency));
    const vat = !!row.withVAT;

    // Ask backend ONLY for this track, thin meta, and a tiny history window
    const params = {
      company: (row.company?.iref || row.company),
      location: loc,
      currency: cur,
      withVAT: vat,
      all_versions: 1,
      history_limit: 10,
      thin: 1,
      fields: 'iref,version,company,currency,withVAT'
    };

    const res = this.state.client.getData(Config.API_URL_LIST_COMPANY, params);
    const rawList = Array.isArray(res) ? res : (res?.results || res?.companyList || []);

    // Normalize in case API mixes strings/numbers for currency/withVAT
    const list = (rawList || []).map(r => ({
      ...r,
      withVAT: (r?.withVAT === true || r?.withVAT === 1 || r?.withVAT === '1' ||
                String(r?.withVAT).toLowerCase() === 'true'),
      currency: (Number.isInteger(r?.currency) ? r.currency : toCurrencyCode(r?.currency)),
      _v: this.parseVersion(r?.version),
    })).filter(r => Number.isFinite(r._v))
      .sort((a,b) => b._v - a._v);
    
    // Keep only the first record per version (sorted desc already)
    const byVersion = new Map();
    for (const r of list) {
      if (!byVersion.has(r._v)) byVersion.set(r._v, r);
    }
    const uniq = Array.from(byVersion.values());

    // Locate current row + previous version on the same track
    const baseV = this.parseVersion(row.version);
    const base = uniq.find(x => x._v === baseV);
    const prev = uniq.find(x => x._v < baseV);

    if (!base || !prev) {
      this.setState({ snack: { open:true, message: 'No previous version for this track.', severity: 'info' } });
      return;
    }

    // Hydrate both details so Compare has names/SKU even for thin rows
    // (uses your existing helper that retries briefly if backend needs to materialize) 
    const baseDet = await this.getHydratedDetailForCompare(base.iref || base.id || base);
    const prevDet = await this.getHydratedDetailForCompare(prev.iref || prev.id || prev);

    const cmpIdx = this.buildNameIndex([baseDet, prevDet]);

    // Build diff (your buildDiff normalizes rows before diffing)
    const diff = this.buildDiff(baseDet, prevDet);

    this.setState({
      cmpOpen: true,
      cmpBase: baseDet,
      cmpOther: prevDet,
      cmpDiff: diff,
      cmpTab: 0,
      cmpIdx
    });
  };

  // =================== COPY TO… (Quick) ===================
  buildCopyDestOptions = (locations) => {
    const opts = (locations || []).map(l => ({
      iref: l.iref || l.id,
      name: l.name || '',
      label: (l.name || l.iref || '')
    }));
    // “All locations” option
    opts.unshift({ iref: '__ALL__', name: 'All locations', label: 'All locations' });
    return opts;
  };
  openCopyPopover = (row, ev) => {
    const tgt = ev?.currentTarget || ev?.target || null;
    const anchorEl =
      (tgt && typeof tgt === 'object' && tgt.nodeType === 1) ? tgt : null;
    // load defaults / last used
    const last = JSON.parse(localStorage.getItem('lc_copy_defaults') || '{}');
    const lastIds = Array.isArray(last.copyDestinations)
      ? last.copyDestinations.map(v => (typeof v === 'string' ? v : v?.iref)).filter(Boolean)
      : [];
    this.setState({
      copyAnchorEl: anchorEl, copySource: row,
      copyDestinations: lastIds,
      copyCompany: last.copyCompany || '',
      copyMode: last.copyMode || 'full',
      copyFilters: last.copyFilters || { categories: [], brands: [], tags: [], changedSince: '' },
      copyEffective: last.copyEffective || 'now',
      copyWhen: last.copyWhen || nowLocalDT(),
      copyCreateDraft: true,
      copyShortName: this.computeShortName(last.copyCompany || (row.company?.iref || row.company) || ''),
    });
  };
  closeCopyPopover = () => { this.setState({ copyAnchorEl: null, copySource: null, copyCompany: '' }); };
  isQuickCopyValid = () => {
    const sel = this.state.copyDestinations || [];
    return sel.length > 0;
  };

  submitQuickCopy = async () => {
    const s = this.state.copySource;
    if (!s) return;

    const sel = this.normalizeIds(this.state.copyDestinations || []);
    const wantsAll = sel.includes('__ALL__');
    const destIds = wantsAll ? [] : sel;

    if (!wantsAll && !destIds.length) {
      return this.setState({
        snack:{ open:true, severity:'error', message:'Pick at least one destination.' }
      });
    }

    const shortName = (this.state.copyShortName || s.shortName || '').trim().slice(0, 16);
    const payload = {
      from_location_id: s.location?.iref || s.location,
      company: (s.company?.iref || s.company),
      from_companyList_version: Number(s.version),
      to_location_ids: destIds,
      to_all_active_locations: wantsAll,
      to_company_id: this.state.copyCompany || undefined,
      mode: this.state.copyMode,
      filters: this.state.copyMode === 'partial' ? this.state.copyFilters : null,
      effective: this.state.copyEffective,
      when: this.state.copyEffective === 'schedule' ? this.state.copyWhen : null,
      create_draft: !!this.state.copyCreateDraft,
      ...(shortName ? { shortName } : {}),
    };

    // persist defaults
    const persistedIds = wantsAll ? ['__ALL__'] : destIds;
    localStorage.setItem('lc_copy_defaults', JSON.stringify({
      copyDestinations: persistedIds,
      copyMode: this.state.copyMode,
      copyFilters: this.state.copyFilters,
      copyEffective: this.state.copyEffective,
      copyWhen: this.state.copyWhen,
      copyCompany: this.state.copyCompany || '',
    }));

    this.setState({ copySubmitting: true }, () => {
      setTimeout(async () => {
        let res = null;
        try { res = await this.state.client.pushData(QUICK_COPY_ENDPOINT(), payload); }
        catch (e) { res = null; }

        this.setState({ copySubmitting: false });

        if (!res || res.status === 'error' || res.detail) {
          this.setState({
            snack:{ open:true, message:'Copy failed. Exported JSON.', severity:'error' }
          });
          downloadBlob(JSON.stringify(payload, null, 2), `company_quickcopy_${todayISO()}.json`, 'application/json');
          return;
        }

        this.setState({
          snack:{ open:true, message: res?.message || 'Draft(s) created', severity:'success' }
        });
        this.closeCopyPopover();
      }, 0);
    });
  };

  // ---------- change detection helpers ----------
  handleCloseRead = () => {
    if (this.hasUnsavedChanges()) {
      this.setState({ confirmCloseOpen:true });
    } else {
      this.setState({ readOpen:false });
    }
  };
  discardChangesAndClose = () => {
    this.setState({
      readOpen:false,
      confirmCloseOpen:false,
      readEditMode:false,
      readEdits:{ products:{}, combos:{} },
      readAdds:{ products:[], combos:[] },
      readRemovals:{ products:new Set(), combos:new Set() },
      metaDirty:false,
      editPriceList:false,
    });
  };
  hasItemChanges = () => {
    if (!this.state.readEditMode) return false;
    const hasEdits = Object.keys(this.state.readEdits.products || {}).length > 0 ||
                     Object.keys(this.state.readEdits.combos || {}).length > 0;
    const hasAdds = (this.state.readAdds.products || []).length > 0 ||
                    (this.state.readAdds.combos || []).length > 0;
    const hasRem = (this.state.readRemovals.products || new Set()).size > 0 ||
                   (this.state.readRemovals.combos || new Set()).size > 0;
    return hasEdits || hasAdds || hasRem;
  };
  hasMetaChanges = () => !!this.state.metaDirty;
  hasUnsavedChanges = () => this.hasItemChanges() || this.hasMetaChanges();
  
  // Build maps of current (original) items by key, to compare edits against
  getCurrentItemMaps = () => {
    const d = this.state.readDetail || {};
    const prodMap = new Map();
    const comboMap = new Map();
    (this.companyProductsOf(d) || []).forEach((row, idx) => {
      const it = this.normalizeProductItem(row, d, idx);
      if (it?.key) prodMap.set(it.key, it);
    });
    (this.companyCombosOf(d) || []).forEach((row, idx) => {
      const it = this.normalizeComboItem(row, d, idx);
      if (it?.key) comboMap.set(it.key, it);
    });
    return { prodMap, comboMap };
  };

  // Only price changes OR add/remove count as "versioning changes"
  hasVersioningChanges = () => {
    if (!this.state.readEditMode) return false;

    const adds = (this.state.readAdds.products || []).length + (this.state.readAdds.combos || []).length;
    const rems = (this.state.readRemovals.products || new Set()).size + (this.state.readRemovals.combos || new Set()).size;
    if (adds > 0 || rems > 0) return true;

    const { prodMap, comboMap } = this.getCurrentItemMaps();

    // Price changes on products
    for (const [k, edit] of Object.entries(this.state.readEdits.products || {})) {
      if (edit && Object.prototype.hasOwnProperty.call(edit, 'price')) {
        const orig = prodMap.get(k);
        const newPrice  = (edit.price === '' || edit.price == null) ? null : Number(edit.price);
        const origPrice = (orig?.price == null ? null : Number(orig.price));
        if (newPrice !== origPrice) return true;
      }
    }
    // Price changes on combos
    for (const [k, edit] of Object.entries(this.state.readEdits.combos || {})) {
      if (edit && Object.prototype.hasOwnProperty.call(edit, 'price')) {
        const orig = comboMap.get(k);
        const newPrice  = (edit.price === '' || edit.price == null) ? null : Number(edit.price);
        const origPrice = (orig?.price == null ? null : Number(orig.price));
        if (newPrice !== origPrice) return true;
      }
    }
    return false; // only isActive toggles (or no changes)
  };

  // ---------- UI ----------
  hydrateCounts = () => {
    const lists = this.state.lists || [];
    const maxFetch = Math.min(lists.length, 20);
    let changed = false;
    const updated = lists.map((r, idx) => {
      if (idx >= maxFetch) return r;
      if ((r.productCount != null || r._prodCount != null) && (r.comboCount != null || r._comboCount != null)) return r;
      if (!r?.iref) return r;
      try {
        const det = this.state.client.getData(`${Config.API_URL_LIST_COMPANY}${r.iref}/`, {});
        const pc = Array.isArray(det?.productCompany_list) ? det.productCompany_list.length : (det?.productCompany_list ? Object.keys(det.productCompany_list).length : 0);
        const cc = Array.isArray(det?.comboCompany_list) ? det.comboCompany_list.length : (det?.comboCompany_list ? Object.keys(det.comboCompany_list).length : 0);
        changed = true;
        return { ...r, productCount: pc, comboCount: cc, _prodCount: pc, _comboCount: cc };
      } catch (e) { return r; }
    });
    if (changed) this.setState({ lists: updated });
  };

  // ---------- VERSION TIMELINE ----------
  addDays = (date, days) => {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  };

  toISODate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    if (Number.isNaN(d.getTime())) return '';
    return d.toISOString().slice(0, 10);
  };

  parseISODateOnly = (value) => {
    if (!value) return null;
    const s = String(value).slice(0, 10);
    const d = new Date(`${s}T00:00:00`);
    return Number.isNaN(d.getTime()) ? null : d;
  };

  diffDaysInclusive = (from, to) => {
    if (!from || !to) return 0;
    const ms = 24 * 60 * 60 * 1000;
    return Math.floor((to.getTime() - from.getTime()) / ms) + 1;
  };

  getSelectedTimelinePeriod = () => {
    const q = this.state.qFilters || {};

    let from = this.parseISODateOnly(q.dateFrom);
    let to = this.parseISODateOnly(q.dateTo);

    if (!to) to = this.parseISODateOnly(todayISO());
    if (!from) from = new Date(to);

    if (from > to) {
      const tmp = from;
      from = to;
      to = tmp;
    }

    return {
      from,
      to,
      totalDays: this.diffDaysInclusive(from, to)
    };
  };

  getTimelinePeriod = () => {
    const selected = this.getSelectedTimelinePeriod();

    let visualFrom = this.addDays(selected.from, -14);
    let visualTo = this.addDays(visualFrom, 90);

    if (selected.totalDays > 60) {
      visualFrom = this.addDays(selected.from, -7);
      visualTo = this.addDays(selected.to, 14);
    }

    const totalDays = this.diffDaysInclusive(visualFrom, visualTo);

    return {
      from: visualFrom,
      to: visualTo,
      selectedFrom: selected.from,
      selectedTo: selected.to,
      totalDays,
    };
  };

  clampDate = (date, min, max) => {
    if (!date) return null;
    if (date < min) return min;
    if (date > max) return max;
    return date;
  };

  versionIsValidOnDay = (version, day) => {
    const from = this.parseISODateOnly(version?.dateFrom);
    const to = this.parseISODateOnly(version?.dateTo) || new Date('2999-12-31T00:00:00');

    if (!from) return false;

    return from <= day && day <= to;
  };

  getEffectiveVersionByDay = (versions, day) => {
    const activeVersions = (versions || [])
      .filter(v => !!v.isActive)
      .filter(v => this.versionIsValidOnDay(v, day))
      .sort((a, b) => Number(b.version || 0) - Number(a.version || 0));

    return activeVersions[0] || null;
  };

  buildVersionTimelineRows = () => {
    const versions = this.state.drawerVersions || [];
    const { from, to } = this.getTimelinePeriod();

    const totalDays = this.diffDaysInclusive(from, to);
    if (!versions.length || totalDays <= 0) {
      return { rows: [], from, to, totalDays };
    }

    const rows = versions
      .slice()
      .sort((a, b) => Number(b.version || 0) - Number(a.version || 0))
      .map((version) => {
        const vFromRaw = this.parseISODateOnly(version.dateFrom);
        const vToRaw = this.parseISODateOnly(version.dateTo) || to;

        if (!vFromRaw) {
          return {
            version,
            hasOverlap: false,
            leftPct: 0,
            widthPct: 0,
            activeSegments: [],
          };
        }

        const start = this.clampDate(vFromRaw, from, to);
        const end = this.clampDate(vToRaw, from, to);
        const hasOverlap = start && end && start <= end;

        if (!hasOverlap) {
          return {
            version,
            hasOverlap: false,
            leftPct: 0,
            widthPct: 0,
            activeSegments: [],
          };
        }

        const leftDays = Math.max(0, this.diffDaysInclusive(from, start) - 1);
        const widthDays = this.diffDaysInclusive(start, end);

        const leftPct = (leftDays / totalDays) * 100;
        const widthPct = (widthDays / totalDays) * 100;

        const activeSegments = [];
        let segStart = null;

        for (let i = 0; i < totalDays; i += 1) {
          const day = this.addDays(from, i);
          const effective = this.getEffectiveVersionByDay(versions, day);
          const isThisEffective =
            effective &&
            String(effective.iref || effective.version) === String(version.iref || version.version);

          if (isThisEffective && !segStart) {
            segStart = day;
          }

          if ((!isThisEffective || i === totalDays - 1) && segStart) {
            const segEnd = isThisEffective && i === totalDays - 1
              ? day
              : this.addDays(day, -1);

            const segLeftDays = Math.max(0, this.diffDaysInclusive(from, segStart) - 1);
            const segWidthDays = this.diffDaysInclusive(segStart, segEnd);

            activeSegments.push({
              from: segStart,
              to: segEnd,
              leftPct: (segLeftDays / totalDays) * 100,
              widthPct: (segWidthDays / totalDays) * 100,
            });

            segStart = null;
          }
        }

        const selected = this.getSelectedTimelinePeriod();
        const isEffectiveInSelectedPeriod = activeSegments.some(seg => {
          const segFrom = seg.from;
          const segTo = seg.to;
          return segFrom <= selected.to && segTo >= selected.from;
        });

        return {
          version,
          hasOverlap,
          leftPct,
          widthPct,
          activeSegments,
          validFrom: start,
          validTo: end,
          isEffectiveInSelectedPeriod,
        };
      });

    return { rows, from, to, totalDays };
  };

  buildTimelineTicks = (from, to) => {
    const totalDays = this.diffDaysInclusive(from, to);
    if (!from || !to || totalDays <= 0) return [];

    const ticks = [];
    const current = new Date(from);

    const day = current.getDay();
    const daysToMonday = day === 0 ? 1 : (8 - day) % 7;
    current.setDate(current.getDate() + daysToMonday);

    let tickIndex = 0;

    while (current <= to) {
      const leftDays = Math.max(0, this.diffDaysInclusive(from, current) - 1);

      ticks.push({
        date: new Date(current),
        leftPct: (leftDays / totalDays) * 100,
        label: current.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short'
        }),
        showLabel: tickIndex % 2 === 0,
      });

      current.setDate(current.getDate() + 7);
      tickIndex += 1;
    }

    return ticks;
  };

  getSelectedRangeStyle = (from, to, selectedFrom, selectedTo, totalDays) => {
    if (!from || !to || !selectedFrom || !selectedTo || totalDays <= 0) return null;

    const start = this.clampDate(selectedFrom, from, to);
    const end = this.clampDate(selectedTo, from, to);

    if (!start || !end || start > end) return null;

    const leftDays = Math.max(0, this.diffDaysInclusive(from, start) - 1);
    const widthDays = Math.max(1, this.diffDaysInclusive(start, end));

    return {
      leftPct: (leftDays / totalDays) * 100,
      widthPct: Math.max(0.8, (widthDays / totalDays) * 100),
    };
  };

  renderVersionTimeline = () => {
    const { rows, from, to, totalDays } = this.buildVersionTimelineRows();
    const visualPeriod = this.getTimelinePeriod();
    const ticks = this.buildTimelineTicks(from, to);

    const selectedStyle = this.getSelectedRangeStyle(
      from,
      to,
      visualPeriod.selectedFrom,
      visualPeriod.selectedTo,
      totalDays
    );

    if (!rows.length) return null;
    const effectiveVersions = rows
      .filter(r => r.isEffectiveInSelectedPeriod)
      .map(r => `v${r.version.version}`);
    const searchedRows = rows.filter(r => r.version._isSearchedVersion);
    const searchedNotEffective = searchedRows.some(r => !r.isEffectiveInSelectedPeriod);

    const periodLabel = `${from.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })} — ${to.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}`;
    const selectedLabel = `${visualPeriod.selectedFrom.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })} — ${visualPeriod.selectedTo.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}`;

    return (
      <Paper
        variant="outlined"
        sx={{
          p: 1,
          mb: 1.25,
          borderRadius: 2,
          bgcolor: 'background.paper',
          borderColor: 'divider'
        }}
      >
        <Stack spacing={0.75}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
            <Box sx={{ minWidth: 0 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
                Version timeline
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.2 }}>
                {periodLabel}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.2 }}>
                Selected: {selectedLabel}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  display: 'block',
                  lineHeight: 1.2,
                  color: searchedNotEffective ? 'warning.main' : 'text.secondary'
                }}
              >
                Effective for selected period: {effectiveVersions.length ? effectiveVersions.join(', ') : 'none'}
                {searchedNotEffective ? ' · searched version is not effective for this period' : ''}
              </Typography>
            </Box>

            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" justifyContent="flex-end">
              <Stack direction="row" spacing={0.5} alignItems="center">
                <Box sx={{ width: 18, height: 8, borderRadius: 99, bgcolor: 'success.main' }} />
                <Typography variant="caption" color="text.secondary">Effective</Typography>
              </Stack>
              <Stack direction="row" spacing={0.5} alignItems="center">
                <Box sx={{ width: 18, height: 8, borderRadius: 99, bgcolor: 'primary.light', opacity: 0.55 }} />
                <Typography variant="caption" color="text.secondary">Valid</Typography>
              </Stack>
              <Stack direction="row" spacing={0.5} alignItems="center">
                <Box sx={{ width: 18, height: 8, borderRadius: 0.75, bgcolor: 'warning.light', opacity: 0.35 }} />
                <Typography variant="caption" color="text.secondary">Selected period</Typography>
              </Stack>
            </Stack>
          </Stack>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '74px 1fr',
              columnGap: 1,
              alignItems: 'end'
            }}
          >
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: 10 }}>
              Ver.
            </Typography>

            <Box sx={{ position: 'relative', height: 18 }}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ position: 'absolute', left: 0, top: 0, fontSize: 10 }}
              >
                {from.toLocaleDateString('en-GB', { month: 'short', year: '2-digit' })}
              </Typography>

              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ position: 'absolute', right: 0, top: 0, fontSize: 10 }}
              >
                {to.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })}
              </Typography>

              {ticks.map((tick, idx) => {
                if (!tick.showLabel) return null;
                if (tick.leftPct < 8 || tick.leftPct > 92) return null;

                return (
                  <Typography
                    key={`${tick.label}_${idx}`}
                    variant="caption"
                    color="text.secondary"
                    sx={{
                      position: 'absolute',
                      left: `${tick.leftPct}%`,
                      top: 0,
                      transform: 'translateX(-50%)',
                      fontSize: 9,
                      whiteSpace: 'nowrap',
                      display: { xs: 'none', sm: 'block' }
                    }}
                  >
                    {tick.label}
                  </Typography>
                );
              })}
            </Box>
          </Box>

          <Stack spacing={0.4}>
            {rows.map((row, idx) => {
              const v = row.version;
              const isEffectiveInPeriod = row.isEffectiveInSelectedPeriod;
              const isSearchedVersion = !!v._isSearchedVersion;

              return (
                <Box
                  key={v.iref || `${v.version}_${idx}`}
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: '74px 1fr',
                    columnGap: 1,
                    alignItems: 'center',
                    minHeight: 28
                  }}
                >
                  <Box sx={{ minWidth: 0 }}>
                    <Stack direction="row" spacing={0.5} alignItems="center" sx={{ minWidth: 0 }}>
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 800,
                          color: isEffectiveInPeriod ? 'success.main' : 'text.primary',
                          lineHeight: 1.05
                        }}
                      >
                        v{v.version}
                      </Typography>

                      {isSearchedVersion && (
                        <Chip
                          size="small"
                          label="Searched"
                          variant="outlined"
                          sx={{ height: 18, fontSize: 10 }}
                        />
                      )}

                      {isEffectiveInPeriod && (
                        <Chip
                          size="small"
                          label="Effective"
                          color="success"
                          sx={{ height: 18, fontSize: 10 }}
                        />
                      )}

                      {v.isActive && !isEffectiveInPeriod && (
                        <Chip
                          size="small"
                          label="Enabled"
                          variant="outlined"
                          sx={{ height: 18, fontSize: 10 }}
                        />
                      )}
                    </Stack>
                  </Box>

                  <Tooltip
                    arrow
                    title={
                      <Box>
                        <Typography variant="caption" sx={{ display: 'block', fontWeight: 700 }}>
                          Version v{v.version}
                        </Typography>

                        <Typography variant="caption" sx={{ display: 'block' }}>
                          Validity: {v.dateFrom || '—'} → {v.dateTo || '∞'}
                        </Typography>

                        <Typography variant="caption" sx={{ display: 'block' }}>
                          Status: {v.isActive ? 'Enabled' : 'Draft / inactive'}
                        </Typography>

                        <Typography variant="caption" sx={{ display: 'block' }}>
                          Selected period: {isEffectiveInPeriod ? 'Effective' : 'Not effective'}
                        </Typography>

                        {isSearchedVersion && (
                          <Typography variant="caption" sx={{ display: 'block' }}>
                            Search result: yes
                          </Typography>
                        )}
                      </Box>
                    }
                  >
                    <Box
                      sx={{
                        position: 'relative',
                        height: 24,
                        borderRadius: 1.25,
                        bgcolor: 'action.hover',
                        overflow: 'hidden',
                        border: '1px solid',
                        borderColor: 'divider'
                      }}
                    >
                      {ticks.map((tick, tickIdx) => (
                        <Box
                          key={tickIdx}
                          sx={{
                            position: 'absolute',
                            left: `${tick.leftPct}%`,
                            top: 0,
                            bottom: 0,
                            width: '1px',
                            bgcolor: 'divider',
                            opacity: 0.7
                          }}
                        />
                      ))}

                      {selectedStyle && (
                        <Box
                          sx={{
                            position: 'absolute',
                            left: `${selectedStyle.leftPct}%`,
                            width: `${selectedStyle.widthPct}%`,
                            top: 0,
                            bottom: 0,
                            bgcolor: 'warning.light',
                            opacity: 0.28
                          }}
                        />
                      )}

                      {row.hasOverlap && (
                        <Box
                          sx={{
                            position: 'absolute',
                            left: `${row.leftPct}%`,
                            width: `${Math.max(row.widthPct, 0.8)}%`,
                            top: 7,
                            height: 10,
                            borderRadius: 99,
                            bgcolor: 'primary.light',
                            opacity: 0.55
                          }}
                        />
                      )}

                      {row.activeSegments.map((seg, segIdx) => (
                        <Box
                          key={segIdx}
                          sx={{
                            position: 'absolute',
                            left: `${seg.leftPct}%`,
                            width: `${Math.max(seg.widthPct, 0.8)}%`,
                            top: 5,
                            height: 14,
                            borderRadius: 99,
                            bgcolor: 'success.main',
                            boxShadow: 1
                          }}
                        />
                      ))}
                    </Box>
                  </Tooltip>
                </Box>
              );
            })}
          </Stack>

          <Typography variant="caption" color="text.secondary" sx={{ fontSize: 10, lineHeight: 1.25 }}>
            <Box component="span" sx={{ display: 'block' }}>
              Effective = enabled version with the highest version number valid for each date.
            </Box>
            <Box component="span" sx={{ display: 'block' }}>
              A searched version is shown for reference, even when it is not effective in the selected period.
            </Box>
          </Typography>
        </Stack>
      </Paper>
    );
  };

  render(){
    const { lists, loading } = this.state;

    // Build locations array for pickers (sorted by name)
    const locationsArr = Object.values(this.state.locations || {})
      .filter(v => v?.iref)
      .sort((a, b) =>
        String(a.name || '').localeCompare(String(b.name || ''), undefined, { sensitivity: 'base' })
      );

    return (
      <div style={{ backgroundColor: '#273442', minHeight: '100%' }}>
        <div className='sticky'>
          <ListsCompanyFilters
            applyFilters={this.applyFilters}
            listsCounter={lists?.length || 0}
            locations={this.state.locations}
            companies={this.state.companies}
            onCreateEmpty={this.handleCreateEmpty}
            sx={{ position: 'sticky', top: 0}}
          />
        </div>


        <Box sx={{ px: 1, py: 1 }}>
          <Stack direction='row' spacing={1} alignItems='center' flexWrap='wrap'>
            <FormControlLabel
              control={<Checkbox checked={!!this.state.showDrafts} onChange={(e)=>{ const v=e.target.checked; this.setState({ showDrafts: v }, ()=>{ try{ localStorage.setItem('lc_showDrafts', JSON.stringify(v)); }catch(e){} this.fetchLatest(this.buildQueryFromFilters()); }); }} />}
              label='Show drafts'
            />
            <Button size='small' variant='outlined' onClick={()=>{ const q={ dateFrom: todayISO(), dateTo: todayISO() }; this.setState({ qFilters: q }, ()=>{ try{ localStorage.setItem('lc_qFilters', JSON.stringify(q)); }catch(e){} const p={ ...q }; if (!this.state.showDrafts) p.status=1; this.fetchLatest(p); }); }}>Valid today</Button>
            <Chip size='small' sx={{ bgcolor: "#455a76", color: "#fff" }} label={`Valid: ${(this.state.qFilters?.dateFrom)||'-'} — ${(this.state.qFilters?.dateTo)||'∞'}`} />
            {!this.state.showDrafts && <Chip size='small' label='Active only' color='primary' variant='outlined' />}
          </Stack>
        </Box>

        <TableContainer component={Paper} sx={{ maxHeight: '68vh', borderRadius: 2, boxShadow: 3, overflow: 'auto' }}>
          <Table aria-label='latest table' size='small' stickyHeader>
             <caption
              style={{
                captionSide: 'top',        // place it above table
                backgroundColor: '#273442', 
                color: '#FFFFFF',
                fontWeight: 'bold',
                textAlign: 'left',
                padding: '8px 16px',
                fontSize: '1.1rem',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px'
              }}
            >
              Company Lists
            </caption>
            <TableHead sx={{backgroundColor: '#273442', color: '#FFFFFF !important'}}>
              <TableRow sx={{backgroundColor: '#273442', color: '#FFFFFF !important'}}>
                <TableCell sx={{backgroundColor: '#273442', color: '#FFFFFF !important'}}>Location</TableCell>
                <TableCell sx={{backgroundColor: '#273442', color: '#FFFFFF !important'}}>Company / Version</TableCell>
                <TableCell sx={{backgroundColor: '#273442', color: '#FFFFFF !important'}}>Items</TableCell>
                <TableCell sx={{backgroundColor: '#273442', color: '#FFFFFF !important'}}>Effective</TableCell>
                <TableCell align='right' sx={{backgroundColor: '#273442', color: '#FFFFFF !important', position:'sticky', right:0, zIndex: 3}}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody
              sx={{
                '& .MuiTableRow-root:nth-of-type(odd)': {
                  bgcolor: 'rgba(255,255,255,0.03)',
                },
                '& .MuiTableRow-root:hover': {
                  bgcolor: 'rgba(255,255,255,0.06) !important',
                },
              }}
            >
              {loading && (
                <TableRow><TableCell colSpan={5}>
                  <Stack alignItems='center' sx={{ py: 3 }}>
                    <Typography variant='body2' color='text.secondary'>Loading…</Typography>
                  </Stack>
                </TableCell></TableRow>
              )}
              {!loading && lists.map((r)=> (
                <TableRow key={String(r.iref)} hover sx={{ '&:hover': { backgroundColor: 'rgba(255,255,255,0.05)' }, height:72 }}>
                  <TableCell><Chip label={r.location?.name || r.location} size='medium' sx={{ fontSize:'0.95rem', fontWeight:500, px:1.2, py:0.6 }}/></TableCell>
                  <TableCell>
                    <Stack direction='row' spacing={0.75} alignItems='center'>
                      <Chip label={r.company?.name || r.company} size='medium' sx={{ fontSize:'0.95rem', px:1.2, py:0.6 }}/>
                      <Chip label={r.shortName} size='medium' sx={{ fontSize:'0.95rem', px:1.2, py:0.6 }}/>
                    </Stack>
                    <Stack direction='row' spacing={0.75} alignItems='center'>
                      <Chip label={`v${r.version}`} size='medium' color='primary' sx={{ fontSize:'0.85rem', px:1, py:0.4 }}/>
                      <Chip label={`${r.iref}`} size='medium' variant='outlined' sx={{ fontSize:'0.75rem', px:1, py:0.4 }}/>
                      <Chip label={toCurrencyName(r.currency)} size='medium' variant='outlined' sx={{ fontSize:'0.85rem', px:1, py:0.4 }}/>
                      <Chip label={r.withVAT? 'VAT':'NoVAT'} size='medium' variant='outlined' sx={{ fontSize:'0.85rem', px:1, py:0.4 }}/>
                      <Chip label={r.isActive ? 'Active' : 'Draft'} size='medium' variant={r.isActive ? 'filled' : 'outlined'} color={r.isActive ? 'success' : 'default'} sx={{ fontSize:'0.85rem', px:1, py:0.4 }}/>
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Stack direction='row' spacing={0.75}>
                      <Chip size='medium' label={`P:${((r.productCount !== undefined && r.productCount !== null) ? r.productCount : (r._prodCount || 0))}`} sx={{ fontSize:'0.8rem', px:1 }}/>
                      <Chip size='medium' label={`C:${((r.comboCount !== undefined && r.comboCount !== null) ? r.comboCount : (r._comboCount || 0))}`} sx={{ fontSize:'0.8rem', px:1 }}/>
                    </Stack>
                  </TableCell>
                  <TableCell>{`${r.dateFrom || ''} — ${r.dateTo || '∞'}`}</TableCell>
                  <TableCell align='right' sx={{ position:'sticky', right:0, backgroundColor: 'background.paper', zIndex: 2 }}>
                    <Stack direction='row' spacing={0.5} justifyContent='flex-end'>
                      <Tooltip title='View'><IconButton onClick={()=>this.openRead(r)}><VisibilityIcon fontSize='inherit'/></IconButton></Tooltip>
                      <Tooltip title='Compare prev'><IconButton onClick={()=>this.openComparePrev(r)}><CompareArrowsIcon fontSize='inherit'/></IconButton></Tooltip>
                      <Tooltip title='History'><IconButton onClick={()=>this.openHistory(r)}><HistoryIcon fontSize='inherit'/></IconButton></Tooltip>
                      <Tooltip title='Copy to… (C)'><IconButton color='primary' onClick={(ev)=>this.openCopyPopover(r, ev)}><ContentCopyIcon fontSize='inherit'/></IconButton></Tooltip>
                      <Tooltip title='Export CSV'>
                        <IconButton
                          onClick={(ev) => {
                            ev.stopPropagation();
                            this.exportCompanyLatestCSV(r);
                          }}
                        >
                          <CloudDownloadIcon fontSize='inherit'/>
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
              {!loading && lists.length === 0 && (
                <TableRow><TableCell colSpan={5}>
                  <Stack alignItems='center' spacing={1} sx={{ py:2 }}>
                    <Typography variant='body2' color='text.secondary'>No price lists for selected filters.</Typography>
                    <Button size='small' variant='outlined' onClick={()=> this.applyFilters({ dateFrom: todayISO(), dateTo: todayISO() })}>Jump to today</Button>
                  </Stack>
                </TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* History Drawer */}
        <Drawer anchor='right' open={this.state.drawerOpen} onClose={()=>this.setState({ drawerOpen:false })}>
          <Box sx={{ width: { xs: '100vw', sm: 720, md: 820 }, p: 1.25 }}>
            <Stack direction='row' alignItems='center' justifyContent='space-between'>
              <Typography variant='subtitle1'>
                History — {this.state.drawerCompany?.name || this.state.drawerCompany || ''} · {this.state.drawerLocation?.name || this.state.drawerLocation?.iref}
              </Typography>

              <IconButton size='small' onClick={()=>this.setState({ drawerOpen:false })}>
                <CloseIcon fontSize='small'/>
              </IconButton>
            </Stack>

            <Divider sx={{ my: 1 }} />

            <Stack direction='row' spacing={1} alignItems='center' sx={{ mb: 1 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.histActiveOnly}
                    onChange={(e)=> {
                      this.setState({ histActiveOnly: e.target.checked }, this.fetchHistoryForLocation);
                    }}
                  />
                }
                label='Active only'
              />

              <TextField
                size='small'
                label='Version #'
                value={this.state.histVersion}
                onChange={(e)=> {
                  const v = e.target.value;
                  this.setState({ histVersion: v });
                  clearTimeout(this.state._histTimer);
                  const t = setTimeout(this.fetchHistoryForLocation, 500);
                  this.setState({ _histTimer: t });
                }}
              />
            </Stack>

            {this.state.drawerLoading && <Typography variant='body2'>Loading…</Typography>}

            {!this.state.drawerLoading && this.renderVersionTimeline()}

            {!this.state.drawerLoading && this.state.drawerVersions.map((v, idx)=> (
              <Stack
                key={v.iref || `${v.version}_${idx}`}
                direction='row'
                alignItems='center'
                justifyContent='space-between'
                sx={{ py: 0.75 }}
              >
                <Stack spacing={0.25}>
                  <Stack direction='row' spacing={0.75} flexWrap="wrap">
                    <Chip label={v.company?.name || v.company || this.state.drawerCompany?.name || ''} size='small'/>
                    {v.shortName && <Chip label={v.shortName} size='small'/>}
                  </Stack>

                  <Stack direction='row' spacing={0.75} flexWrap="wrap">
                    <Chip label={`v${v.version}`} size='small' color='primary'/>
                    <Chip label={`${v.iref}`} size='small' variant='outlined'/>
                    <Chip label={toCurrencyName(v.currency)} size='small' variant='outlined'/>
                    <Chip label={v.withVAT ? 'VAT' : 'NoVAT'} size='small' variant='outlined'/>
                    <Chip label={v.isActive ? 'Active' : 'Draft'} size='small' />
                  </Stack>

                  <Typography variant='caption'>
                    {v.dateFrom || ''} — {v.dateTo || '∞'} • P:{((v.productCount !== undefined && v.productCount !== null) ? v.productCount : (v._prodCount || 0))} C:{((v.comboCount !== undefined && v.comboCount !== null) ? v.comboCount : (v._comboCount || 0))}
                  </Typography>
                </Stack>

                <Stack direction='row' spacing={0.5}>
                  <Tooltip title='View'>
                    <IconButton size='small' onClick={()=>this.openRead(v)}>
                      <VisibilityIcon fontSize='inherit'/>
                    </IconButton>
                  </Tooltip>
                </Stack>
              </Stack>
            ))}
          </Box>
        </Drawer>

        {/* Full-screen Details Dialog with Meta edit toggle + Add/Remove */}
        <Dialog
          open={this.state.readOpen}
          fullWidth
          maxWidth="xl"
          PaperProps={{
            sx: {
              width: '90%',
              height: '90%',
              margin: 'auto',
            },
          }}
          disableEscapeKeyDown
          onClose={(_, reason) => {
            // ignore backdrop clicks
            if (reason === 'backdropClick') return;
            if (this.hasUnsavedChanges()) {
              this.setState({ confirmCloseOpen: true });
            } else {
              this.setState({ readOpen: false });
            }
          }}
        >
          <DialogTitle sx={{ pr: 6 }}>
            {/* {this.state.readDetail?.location?.name || 'Price List'} */}
            <IconButton
              aria-label="close"
              onClick={() => this.handleAttemptCloseRead()}
              sx={{ position:'absolute', right:8, top:8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogTitle sx={{ py: 1.25 }}>
            Company List — {(this.state.readDetail?.company?.name || this.state.readDetail?.company)} · {this.state.readDetail?.location?.name || this.state.readDetail?.location?.iref} · v{this.state.readDetail?.version} · {this.state.readDetail?.iref} ({toCurrencyName(this.state.readDetail?.currency)}, {this.state.readDetail?.withVAT? 'VAT':'NoVAT'})
          </DialogTitle>
          <DialogContent dividers sx={{ p: 1.5, minHeight: 560 }}>
            {this.state.readDetail && (
              <>
                {/* Meta (no new version) */}
                <Paper variant='outlined' sx={{ p: 1, mb: 1 }}>
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{ flexWrap: 'wrap', rowGap: 1 }}
                  >
                    <TextField
                      label='Company'
                      select
                      value={(this.state.metaCompany || (this.state.readDetail?.company?.iref || this.state.readDetail?.company) || '')}
                      onChange={(e)=> {
                        const nextCompany = e.target.value;
                        this.setState({
                          metaCompany: nextCompany,
                          metaDirty: true,
                          metaShortName: this.computeShortName(nextCompany), // optional: keep state in sync
                        });
                      }}
                      size='small'
                      sx={{ minWidth: 220 }}
                      disabled={!this.state.editPriceList}
                    >
                      {Object.values(this.state.companies || {})
                        .filter(c=>c?.iref)
                        .sort((a,b)=> String(a.name||'').localeCompare(String(b.name||''), undefined, {sensitivity:'base'}))
                        .map(c => <MenuItem key={c.iref} value={c.iref}>{c.name || c.iref}</MenuItem>)}
                    </TextField>
                    <TextField
                      label="Short name"
                      value={this.computeShortName(this.state.metaCompany || (this.state.readDetail?.company?.iref || this.state.readDetail?.company))}
                      size="small"
                      sx={{ minWidth: 160 }}
                      disabled
                    />
                    <TextField
                      label='From'
                      type='date'
                      value={this.state.metaDateFrom}
                      onChange={(e)=> this.setState({ metaDateFrom: e.target.value, metaDirty:true })}
                      InputLabelProps={{ shrink: true }}
                      sx={{ minWidth: 140 }}
                      size='small'
                      disabled={!this.state.editPriceList}
                    />
                    <TextField
                      label='To'
                      type='date'
                      value={this.state.metaDateTo}
                      onChange={(e)=> this.setState({ metaDateTo: e.target.value, metaDirty:true })}
                      InputLabelProps={{ shrink: true }}
                      sx={{ minWidth: 140 }}
                      size='small'
                      disabled={!this.state.editPriceList}
                    />
                    <Tooltip title={this.state.metaDescription || ''} arrow placement="top-start">
                      <TextField
                        label='Description'
                        value={this.state.metaDescription || ''}
                        onChange={(e)=> this.setState({ metaDescription: e.target.value, metaDirty: true })}
                        size='small'
                        sx={{ minWidth: 240 }}
                        disabled={!this.state.editPriceList}
                        inputProps={{ style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } }}
                      />
                    </Tooltip>
                    <TextField
                      label='Currency'
                      select
                      value={this.state.metaCurrency || ''}
                      onChange={(e)=> this.setState({ metaCurrency: e.target.value, metaDirty: true })}
                      size='small'
                      sx={{ minWidth: 80 }}
                      disabled={!this.state.editPriceList}
                    >
                      <MenuItem value="RON">RON</MenuItem>
                      <MenuItem value="EUR">EUR</MenuItem>
                      <MenuItem value="USD">USD</MenuItem>
                    </TextField>
                    <Tooltip
                      title="Defines whether prices include VAT. Changing this will not create a new version, but will affect how prices are displayed and calculated."
                      arrow
                      placement="top"
                      disableFocusListener
                      disableInteractive
                      enterDelay={500}
                    >
                      <TextField
                        label="VAT"
                        select
                        size="small"
                        value={this.state.metaWithVAT ? 'vat' : 'no_vat'}
                        onChange={(e) => this.setState({
                          metaWithVAT: e.target.value === 'vat',
                          metaDirty: true
                        })}
                        disabled={!this.state.editPriceList}
                        sx={{ minWidth: 115 }}
                      >
                        <MenuItem value="vat">With VAT</MenuItem>
                        <MenuItem value="no_vat">No VAT</MenuItem>
                      </TextField>
                    </Tooltip>
                    <FormControlLabel
                      control={<Checkbox checked={this.state.metaIsActive} onChange={(e)=> this.setState({ metaIsActive: e.target.checked, metaDirty:true })} disabled={!this.state.editPriceList} />}
                      label='Active'
                    />
                    <Box flexGrow={1} />
                    <Stack direction='row' spacing={1} alignItems='center'>
                      <Tooltip title='Edit period / active'>
                        <IconButton size='small' onClick={()=> this.setState({ editPriceList: !this.state.editPriceList })}>
                          <EditIcon sx={{ color: this.state.editPriceList ? '#8f241d' : '#e3e3e5' }} />
                        </IconButton>
                      </Tooltip>
                      {this.state.editPriceList && (
                        <>
                          <Button size='small' variant='outlined' onClick={()=> this.setState({
                            editPriceList: false,
                            metaDirty: false,
                            metaDateFrom: this.state.readDetail.dateFrom || todayISO(),
                            metaDateTo: this.state.readDetail.dateTo || '',
                            metaIsActive: this.state.readDetail.isActive !== undefined ? !!this.state.readDetail.isActive : true,
                            metaWithVAT: !!this.state.readDetail.withVAT,
                            metaCurrency: toCurrencyName(this.state.readDetail.currency),
                            metaDescription: this.state.readDetail.description || '',
                          })}>
                            Cancel
                          </Button>
                          <Tooltip title='Save metadata (no new version)'>
                            <span>
                              <Button size='small' startIcon={<SaveIcon/>} variant='contained' disabled={!this.state.metaDirty} onClick={this.saveMeta}>
                                Save
                              </Button>
                            </span>
                          </Tooltip>
                        </>
                      )}
                    </Stack>
                  </Stack>
                </Paper>

                <Stack direction='row' alignItems='center' justifyContent='space-between'>
                  <Stack direction='row' spacing={2}>
                    <Typography variant='caption' color='text.secondary'>Effective: {this.state.readDetail.dateFrom || ''} — {this.state.readDetail.dateTo || '∞'}</Typography>
                    <Typography variant='caption' color='text.secondary'>Created on: {this.state.readDetail.createdOn || ''}</Typography>
                  </Stack>
                  <Stack direction='row' spacing={1} flexWrap='wrap' justifyContent='flex-end'>
                    {this.canImportCompanyCsv() && (
                      <>
                        <input
                          id="company-list-csv-import"
                          type="file"
                          accept=".csv,text/csv"
                          style={{ display: 'none' }}
                          onChange={this.handleCompanyCsvSelected}
                        />

                        <Tooltip title="CSV columns: type, iref, price">
                          <Button
                            size='small'
                            variant='outlined'
                            startIcon={this.state.csvImporting ? <CircularProgress size={16} /> : <UploadFileIcon />}
                            onClick={() => document.getElementById('company-list-csv-import')?.click()}
                            disabled={this.state.csvImporting}
                          >
                            Import CSV
                          </Button>
                        </Tooltip>

                        <Tooltip title="Download CSV template">
                          <Button
                            size='small'
                            variant='text'
                            startIcon={<CloudDownloadIcon />}
                            onClick={this.downloadCompanyImportTemplate}
                          >
                            Template
                          </Button>
                        </Tooltip>
                      </>
                    )}

                    {!this.state.readEditMode && (
                      <Button size='small' variant='contained' onClick={()=>this.setState({ readEditMode:true })}>Edit items</Button>
                    )}
                    {this.state.readEditMode && (() => {
                      const anyChanged   = this.hasItemChanges();       // adds/removals/edits of any kind
                      const versioning   = this.hasVersioningChanges(); // price changes OR add/remove only
                      const label        = versioning ? 'Save items (create new version)' : 'Save items';
                      return (
                        <>
                          <Button
                            size='small'
                            variant='outlined'
                            onClick={()=>this.setState({
                              readEditMode:false,
                              readEdits:{ products:{}, combos:{} },
                              readAdds:{ products:[], combos:[] },
                              readRemovals:{ products:new Set(), combos:new Set() }
                            })}
                          >
                            Cancel
                          </Button>
                          <Button
                            size='small'
                            variant='contained'
                            onClick={()=>this.saveNewVersionFromEdits(true)}
                            disabled={!anyChanged || this.state.savingItems}
                          >
                            {this.state.savingItems ? <CircularProgress size={18} sx={{ mr: 1 }} /> : null}
                            {label}
                          </Button>
                        </>
                      );
                    })()}
                  </Stack>
                </Stack>

                <Tabs value={this.state.readTab} onChange={(e,v)=>this.setState({ readTab:v })} sx={{ mt: 1 }}>
                  <Tab label={`Products (${this.state.readDetail._prodCount||0})`} />
                  <Tab label={`Combos (${this.state.readDetail._comboCount||0})`} />
                </Tabs>

                {/* Add bars (preloaded) */}
                {this.state.readEditMode && this.state.readTab === 0 && (
                  <Stack direction='row' spacing={1} alignItems='center' sx={{ mt: 1, flexWrap:'wrap' }}>
                    <Autocomplete
                      size="small"
                      sx={{ minWidth: 340, flex: '1 1 340px', maxWidth: 520 }}
                      options={this.state.prodOptions}
                      value={this.state.prodSelected}
                      inputValue={this.state.prodAddQuery}
                      getOptionLabel={(option) => option?.name || ''}
                      isOptionEqualToValue={(option, value) =>
                        String(option?.iref || '') === String(value?.iref || '')
                      }
                      onChange={(e, val) => {
                        const q = val?.name || '';
                        this.setState({
                          prodSelected: val,
                          prodAddQuery: q,
                          prodOptions: this.filterProducts(q)
                        });
                      }}
                      onInputChange={(e, val, reason) => {
                        if (reason === 'reset') return;
                        this.setState((prev) => {
                          const selectedName = prev.prodSelected?.name || '';
                          return {
                            prodSelected: selectedName && val !== selectedName ? null : prev.prodSelected,
                            prodAddQuery: val || '',
                            prodOptions: this.filterProducts(val || '')
                          };
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select product"
                          placeholder="Type to filter"
                          size="small"
                        />
                      )}
                    />
                    <TextField
                      size='small'
                      label='Price'
                      value={this.state.prodPriceInput}
                      onChange={(e) => {
                        const value = e.target.value;

                        if (/^\d*\.?\d{0,2}$/.test(value) && (Number(value) >= 0 || value === '')) {
                          this.setState({ prodPriceInput: value });
                        }
                      }}
                      sx={{ width: 120 }}
                    />
                    <Stack direction='row' alignItems='center' spacing={1}>
                      <Checkbox size='small' checked={this.state.prodActiveInput} onChange={(e)=> this.setState({ prodActiveInput: e.target.checked })} />
                      <Typography variant='body2'>Active</Typography>
                    </Stack>
                    <Button
                      size='small'
                      startIcon={<AddCircleOutlineIcon/>}
                      onClick={this.addNewProduct}
                      disabled={
                        !this.state.prodSelected ||
                        this.state.prodPriceInput === '' ||
                        isNaN(Number(this.state.prodPriceInput)) ||
                        this.existsInCurrent(this.state.prodSelected?.iref, false)
                      }
                    >
                      {this.existsInCurrent(this.state.prodSelected?.iref, false) ? 'Already in list' : 'Add'}
                    </Button>
                  </Stack>
                )}
                {this.state.readEditMode && this.state.readTab === 1 && (
                  <Stack direction='row' spacing={1} alignItems='center' sx={{ mt: 1, flexWrap:'wrap' }}>
                    <Autocomplete
                      size="small"
                      sx={{ minWidth: 340, flex: '1 1 340px', maxWidth: 520 }}
                      options={this.state.comboOptions}
                      value={this.state.comboSelected}
                      inputValue={this.state.comboAddQuery}
                      getOptionLabel={(option) => option?.name || ''}
                      isOptionEqualToValue={(option, value) =>
                        String(option?.iref || '') === String(value?.iref || '')
                      }
                      onChange={(e, val) => {
                        const q = val?.name || '';
                        this.setState({
                          comboSelected: val,
                          comboAddQuery: q,
                          comboOptions: this.filterCombos(q)
                        });
                      }}
                      onInputChange={(e, val, reason) => {
                        if (reason === 'reset') return;
                        this.setState((prev) => {
                          const selectedName = prev.comboSelected?.name || '';
                          return {
                            comboSelected: selectedName && val !== selectedName ? null : prev.comboSelected,
                            comboAddQuery: val || '',
                            comboOptions: this.filterCombos(val || '')
                          };
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select combo"
                          placeholder="Type to filter"
                          size="small"
                        />
                      )}
                    />
                    <TextField
                      size='small'
                      label='Price'
                      value={this.state.comboPriceInput}
                      onChange={(e) => {
                        const value = e.target.value;

                        if (/^\d*\.?\d{0,2}$/.test(value) && (Number(value) >= 0 || value === '')) {
                          this.setState({ comboPriceInput: value });
                        }
                      }}
                      sx={{ width: 120 }}
                    />
                    <Stack direction='row' alignItems='center' spacing={1}>
                      <Checkbox size='small' checked={this.state.comboActiveInput} onChange={(e)=> this.setState({ comboActiveInput: e.target.checked })} />
                      <Typography variant='body2'>Active</Typography>
                    </Stack>
                    <Button
                      size='small'
                      startIcon={<AddCircleOutlineIcon/>}
                      onClick={this.addNewCombo}
                      disabled={
                        !this.state.comboSelected ||
                        this.state.comboPriceInput === '' ||
                        isNaN(Number(this.state.comboPriceInput)) ||
                        this.existsInCurrent(this.state.comboSelected?.iref, true)
                      }
                    >
                      {this.existsInCurrent(this.state.comboSelected?.iref, true) ? 'Already in list' : 'Add'}
                    </Button>
                  </Stack>
                )}

                {/* Products tab */}
                {this.state.readTab === 0 && (
                  <Paper variant='outlined' sx={{ mt: 1, minHeight: 420 }}>
                    {this.state.readLoading ? (
                      <Box sx={{ p: 2 }}><CircularProgress size={24} /> Loading…</Box>
                    ) : (
                      <Table size='small' stickyHeader>
                        <TableHead>
                          <TableRow sx={{ backgroundColor: 'rgba(0,0,0,0.04)' }}>
                            <TableCell sx={{ fontWeight: 'bold', color: '#444' }}>Image</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: '#444' }}>Name</TableCell>
                            {/* <TableCell sx={{ fontWeight: 'bold', color: '#444' }}>SKU</TableCell> */}
                            <TableCell sx={{ fontWeight: 'bold', color: '#444' }}>Categ. / Subcateg.</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: '#444' }} align='center'>Price</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: '#444' }}>Active</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: '#444' }}>For Sale</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: '#444' }}>Sold Alone</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: '#444' }}>Status</TableCell>
                            {this.state.readEditMode && <TableCell />}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {/* New product rows */}
                          {this.state.readEditMode && (this.state.readAdds.products || [])
                            .map((n, idxN) => ({ n, idxN }))
                            .filter(({ n }) => this.matchesAddQuery(n, this.state.prodAddQuery))
                            .map(({ n, idxN }) => (
                            <TableRow
                              key={`newprod_${idxN}`}
                              hover
                              sx={{ backgroundColor: 'rgba(76,175,80,0.08)' }}
                            >
                              <TableCell>-</TableCell>
                              <TableCell>
                                <Typography variant='body2'>{n.product_name || n.product_iref}</Typography>
                              </TableCell>
                              {/* <TableCell>-</TableCell> */}
                              <TableCell>-</TableCell>
                              <TableCell align='center'>{n.price}</TableCell>
                              <TableCell>
                                <Checkbox size='small' checked={!!n.isActive} readOnly />
                              </TableCell>
                              <TableCell>
                                {n.isForSale ? 'Yes' : 'No'}
                              </TableCell>
                              <TableCell>
                                {n.isForSale ? 'Yes' : 'No'}
                              </TableCell>
                              <TableCell>
                                {n.status ?? '—'}
                              </TableCell>
                              <TableCell>
                                <IconButton size='small' onClick={()=> this.removeNewRow('products', idxN)}>
                                  <DeleteOutlineIcon fontSize='inherit' />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                          {this.companyProductsOf(this.state.readDetail)
                          .map((row, idx) => this.normalizeProductItem(row, this.state.readDetail, idx))
                          .filter(item => this.matchesAddQuery(item, this.state.prodAddQuery))
                          .sort((a,b)=> (a.name || '').localeCompare(b.name || ''))
                          .map((item)=>{
                            const edited = {
                              price: item.price,
                              isActive: item.isActive,
                              ...(this.state.readEdits.products[item.key] || {})
                            };
                            const removed = this.state.readRemovals.products.has(item.key);
                            return (
                              <TableRow
                                key={item.key}
                                hover
                                sx={{
                                  borderBottom: '1px solid rgba(0,0,0,0.08)',
                                  '&:hover': { backgroundColor: 'rgba(0,0,0,0.02)' },
                                  opacity: removed ? 0.5 : 1,
                                  backgroundColor: (this.state.readEditMode && !!this.state.readEdits.products[item.key])
                                    ? 'rgba(255, 255, 200, 0.2)' // subtle yellow tint for edited rows
                                    : undefined
                                }}
                              >
                                <TableCell><Box component='img' alt='No Image' src={item.img} sx={{ width:48, height:48, border:'1px dashed grey' }} /></TableCell>
                                <TableCell>{item.name || item.sku || item.product_iref || '—'}</TableCell>
                                {/* <TableCell>{item.sku}</TableCell> */}
                                <TableCell>
                                  <Stack direction="row" spacing={1}>
                                    {item?.pCategory?.image && (
                                      <Avatar
                                        title={item.pCategory.name}
                                        alt={item.pCategory.name}
                                        src={this.getThumbFromImages([{ image: item.pCategory.image }])}
                                        sx={{ width: 48, height: 48 }}
                                      />
                                    )}
                                    {item?.pSubCategory?.image && (
                                      <Avatar
                                        title={item.pSubCategory.name}
                                        alt={item.pSubCategory.name}
                                        src={this.getThumbFromImages([{ image: item.pSubCategory.image }])}
                                        sx={{ width: 48, height: 48 }}
                                      />
                                    )}
                                  </Stack>
                                </TableCell>
                                <TableCell align='center'>
                                  {this.state.readEditMode ? (
                                    <TextField
                                      size='small'
                                      value={edited.price != null ? edited.price : Number(item.price).toFixed(2)}
                                      onChange={(e) => {
                                        const value = e.target.value;

                                        // ✅ minimal change: restrict decimals
                                        if ((/^\d*\.?\d{0,2}$/.test(value)) && (Number(value) >= 0 || value === '')) {
                                          this.setEdit('products', item.key, 'price', value);
                                        }
                                      }}
                                      sx={{ maxWidth: 140, '& .MuiInputBase-input': { textAlign: 'center' } }}
                                    />
                                  ) : (
                                    Number(item.price).toFixed(2)
                                  )}
                                </TableCell>
                                <TableCell>
                                  <Checkbox size='small' checked={!!(edited.isActive)} disabled={!this.state.readEditMode} onChange={(e)=>this.setEdit('products', item.key, 'isActive', e.target.checked)} />
                                </TableCell>
                                <TableCell>
                                  {item.isForSale == null ? '—' : (item.isForSale ? 'Yes' : 'No')}
                                </TableCell>
                                <TableCell>
                                  {item.isSoldAlone == null ? '—' : (item.isSoldAlone ? 'Yes' : 'No')}
                                </TableCell>
                                <TableCell>
                                  {item.status != null && item.status !== '' ? item.status : '—'}
                                </TableCell>
                                {this.state.readEditMode && (
                                  <TableCell>
                                    <IconButton size='small' onClick={()=> this.toggleRemoval('products', item.key)}><DeleteOutlineIcon fontSize='inherit' /></IconButton>
                                  </TableCell>
                                )}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    )}
                  </Paper>
                )}

                {/* Combos tab */}
                {this.state.readTab === 1 && (
                  <Paper variant='outlined' sx={{ mt: 1, minHeight: 420 }}>
                    {this.state.readLoading ? (
                      <Box sx={{ p: 2 }}><CircularProgress size={24} /> Loading…</Box>
                    ) : (
                      <Table size='small' stickyHeader>
                        <TableHead>
                          <TableRow sx={{ backgroundColor: 'rgba(0,0,0,0.04)' }}>
                            <TableCell sx={{ fontWeight: 'bold', color: '#444' }}>Image</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: '#444' }}>Name</TableCell>
                            {/* <TableCell sx={{ fontWeight: 'bold', color: '#444' }}>SKU</TableCell> */}
                            <TableCell sx={{ fontWeight: 'bold', color: '#444' }} align='center'>Price</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: '#444' }}>Active</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: '#444' }}>For Sale</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: '#444' }}>Status</TableCell>
                            {this.state.readEditMode && <TableCell />}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {/* New combo rows */}
                          {this.state.readEditMode && (this.state.readAdds.combos || [])
                            .map((n, idxN) => ({ n, idxN }))
                            .filter(({ n }) => this.matchesAddQuery(n, this.state.comboAddQuery))
                            .map(({ n, idxN }) => (
                            <TableRow
                              key={`newcombo_${idxN}`}
                              hover
                              sx={{ backgroundColor: 'rgba(76,175,80,0.08)' }}
                            >
                              <TableCell>-</TableCell>
                              <TableCell>
                                <Typography variant='body2'>{n.combo_name || n.combo_iref}</Typography>
                              </TableCell>
                              {/* <TableCell>-</TableCell> */}
                              <TableCell align='center'>{n.price}</TableCell>
                              <TableCell>
                                <Checkbox size='small' checked={!!n.isActive} readOnly />
                              </TableCell>
                              <TableCell>
                                {n.isForSale ? 'Yes' : 'No'}
                              </TableCell>
                              <TableCell>
                                {n.status ?? '—'}
                              </TableCell>
                              <TableCell>
                                <IconButton size='small' onClick={()=> this.removeNewRow('combos', idxN)}>
                                  <DeleteOutlineIcon fontSize='inherit' />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                          {this.companyCombosOf(this.state.readDetail)
                            .map((row, idx) => this.normalizeComboItem(row, this.state.readDetail, idx))
                            .filter(item => this.matchesAddQuery(item, this.state.comboAddQuery))
                            .sort((a,b)=> (a.name || '').localeCompare(b.name || ''))
                            .map((item)=>{
                            const edited = {
                              price: item.price,
                              isActive: item.isActive,
                              ...(this.state.readEdits.combos[item.key] || {})
                            };
                            const removed = this.state.readRemovals.combos.has(item.key);
                            return (
                              <TableRow
                                key={item.key} 
                                hover
                                sx={{
                                  borderBottom: '1px solid rgba(0,0,0,0.08)',
                                  '&:hover': { backgroundColor: 'rgba(0,0,0,0.02)' },
                                  opacity: removed ? 0.5 : 1,
                                  backgroundColor: (this.state.readEditMode && !!this.state.readEdits.combos[item.key])
                                    ? 'rgba(255, 255, 200, 0.2)' // subtle yellow tint for edited rows
                                    : undefined
                                }}
                              >
                                <TableCell><Box component='img' alt='No Image' src={item.img} sx={{ width:48, height:48, border:'1px dashed grey' }} /></TableCell>
                                <TableCell>{item.name || item.sku || item.combo_iref || '—'}</TableCell>
                                {/* <TableCell>{item.sku}</TableCell> */}
                                <TableCell align='center'>
                                  {this.state.readEditMode ? (
                                    <TextField
                                      size='small'
                                      value={edited.price != null ? edited.price : Number(item.price).toFixed(2)}
                                      onChange={(e) => {
                                        const value = e.target.value;

                                        if (/^\d*\.?\d{0,2}$/.test(value) && (Number(value) >= 0 || value === '')) {
                                          this.setEdit('combos', item.key, 'price', value);
                                        }
                                      }}
                                      sx={{
                                        maxWidth: 140,
                                        '& .MuiInputBase-input': { textAlign: 'center' }
                                      }}
                                    />
                                  ) : (
                                    Number(item.price).toFixed(2)
                                  )}
                                </TableCell>
                                <TableCell>
                                  <Checkbox size='small' checked={!!(edited.isActive)} disabled={!this.state.readEditMode} onChange={(e)=>this.setEdit('combos', item.key, 'isActive', e.target.checked)} />
                                </TableCell>
                                <TableCell>
                                  {item.isForSale == null ? '—' : (item.isForSale ? 'Yes' : 'No')}
                                </TableCell>
                                <TableCell>
                                  {item.status != null && item.status !== '' ? item.status : '—'}
                                </TableCell>
                                {this.state.readEditMode && (
                                  <TableCell>
                                    <IconButton size='small' onClick={()=> this.toggleRemoval('combos', item.key)}><DeleteOutlineIcon fontSize='inherit' /></IconButton>
                                  </TableCell>
                                )}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    )}
                  </Paper>
                )}
              </>
            )}
          </DialogContent>
          <DialogActions>
            {(this.state.readEditMode && this.hasItemChanges()) && (
              <Button size='small' variant='contained' onClick={()=> this.saveNewVersionFromEdits(true)} disabled={this.state.savingItems}>
                {this.state.savingItems ? <CircularProgress size={18} sx={{ mr: 1 }} /> : null}
                Save items & Close
              </Button>
            )}
            {(!this.hasItemChanges() && this.hasMetaChanges()) && (
              <Button size='small' variant='contained' onClick={()=> this.saveMeta(true)}>
                Save meta & Close
              </Button>
            )}
            <Button size='small' variant='outlined' startIcon={<CloudDownloadIcon/>} onClick={this.exportCompanyDetailCSV}>
              Export CSV
            </Button>
            <Button onClick={this.handleCloseRead}>Close</Button>
          </DialogActions>
        </Dialog>

        {/* Confirm close (unsaved changes) */}
        <Dialog open={this.state.confirmCloseOpen} onClose={() => {}}>
          <DialogTitle>Discard changes?</DialogTitle>
          <DialogContent dividers>
            <Typography variant="body2">You have unsaved changes. If you close now, they will be lost.</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=> this.setState({ confirmCloseOpen:false })}>Cancel</Button>
            <Button color="error" variant="contained" onClick={()=> this.setState({ confirmCloseOpen:false, readOpen:false, readEditMode:false, metaDirty:false })}>Discard</Button>
          </DialogActions>
        </Dialog>

        {/* COPY TO… POPOVER */}
        <Popover
          open={Boolean(
            typeof this.state.copyAnchorEl === 'function' ||
            (this.state.copyAnchorEl && this.state.copyAnchorEl.nodeType === 1)
              ? this.state.copyAnchorEl
              : null
          )}
          anchorEl={
            typeof this.state.copyAnchorEl === 'function' ||
            (this.state.copyAnchorEl && this.state.copyAnchorEl.nodeType === 1)
              ? this.state.copyAnchorEl
              : null
          }
          onClose={this.closeCopyPopover}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Box sx={{ p: 2, width: 420, maxWidth: '100%' }}>
            <Typography variant='subtitle2' gutterBottom>Copy to…</Typography>

            <TextField
              id="copy-select-locations"
              label="Destination locations"
              select
              variant="standard"
              fullWidth
              sx={{ mb: 1 }}
              SelectProps={{
                multiple: true,
                value: this.state.copyDestinations || [],  // array of iref (strings)
                onChange: (e) => {
                  const value = e.target.value; // array (MUI multiple)
                  // if "__ALL__", collapse selection to just ["__ALL__"]
                  const next = value.includes('__ALL__') ? ['__ALL__'] : value.filter(v => v !== '__ALL__');
                  this.setState({ copyDestinations: next });
                },
                renderValue: (selected) => {
                  if (!selected || !selected.length) return '';
                  if (selected.includes('__ALL__')) return 'All locations';
                  const locations = Object.values(this.state.locations || {});
                  return selected
                    .map(v => locations.find(l => l.iref === v)?.name || v)
                    .join(', ');
                },
              }}
            >
              {/* "All locations" option */}
              <MenuItem key="__ALL__" value="__ALL__">
                <Checkbox checked={this.state.copyDestinations.includes('__ALL__')} />
                <ListItemText primary="All locations" primaryTypographyProps={{ fontWeight: this.state.copyDestinations.includes('__ALL__') ? 600 : 400 }} />
              </MenuItem>

              {/* Sorted by name */}
              {Object.values(this.state.locations || {})
                .filter(o => !!o?.iref)
                .sort((a,b)=> String(a.name||'').localeCompare(String(b.name||''), undefined, {sensitivity:'base'}))
                .map((option) => {
                  const checked = this.state.copyDestinations.indexOf(option.iref) > -1;
                  return (
                    <MenuItem key={option.iref} value={option.iref}>
                      <Checkbox checked={checked} />
                      <ListItemText
                        primary={option.name}
                        primaryTypographyProps={{ fontWeight: checked ? 600 : 400 }}
                      />
                    </MenuItem>
                  );
                })}
            </TextField>
            <TextField
              id="copy-select-company"
              label="Destination company (optional)"
              select
              variant="standard"
              fullWidth
              sx={{ mb: 1 }}
              value={this.state.copyCompany || ''}
              onChange={(e) => {
                const next = e.target.value;
                this.setState({
                  copyCompany: next,
                  copyShortName: this.computeShortName(next),
                });
              }}
            >
              <MenuItem value=""><em>Keep source company</em></MenuItem>
              {Object.values(this.state.companies || {})
                .sort((a,b)=> String(a.name||'').localeCompare(String(b.name||''), undefined, {sensitivity:'base'}))
                .map(c => (
                  <MenuItem key={c.iref} value={c.iref}>
                    {c.name || c.iref}
                  </MenuItem>
                ))}
            </TextField>
            <TextField
              label="Short name (destination)"
              size="small"
              fullWidth
              value={this.state.copyShortName || ''}
              onChange={(e) => this.setState({ copyShortName: e.target.value.slice(0, 16) })}
              inputProps={{ maxLength: 16 }}
            />

            {this.state.copySubmitting && <LinearProgress sx={{ my: 1 }} />}

            <Stack direction='row' spacing={1} justifyContent='flex-end' sx={{ mt: 1 }}>
              <Button onClick={this.closeCopyPopover}>Cancel</Button>
              <Button variant='contained' onClick={this.submitQuickCopy} disabled={!this.isQuickCopyValid() || this.state.copySubmitting}>Copy</Button>
            </Stack>
          </Box>
        </Popover>

        {/* COMPARE DIALOG */}
        <Dialog
          open={this.state.cmpOpen}
          onClose={() => {}}
          fullWidth
          maxWidth="lg"
          PaperProps={{
            sx: {
              height: '80vh',          // fixed height (80% of viewport)
              display: 'flex',
              flexDirection: 'column',
            },
          }}
        >
          <DialogTitle sx={{ pb: 0.5, pt: 1.5 }}>
            {this.nameOf(this.state.cmpBase?.location, this.state.locations)}
            {' — '}
            {this.nameOf(this.state.cmpBase?.company,  this.state.companies)}
            {' · '}
            Compare v{this.state.cmpBase?.version} ↔ v{this.state.cmpOther?.version}
            <IconButton
              aria-label="close"
              onClick={()=> this.setState({ cmpOpen:false })}
              sx={{ position:'absolute', right:8, top:8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers sx={{ flex: 1, overflowY: 'auto', p: 0 }}>
            <Stack direction="row" spacing={2} sx={{ mb: 2 }} alignItems="center">
              <Chip label={`Products: +${this.state.cmpDiff?.products?.summary?.added || 0} / -${this.state.cmpDiff?.products?.summary?.removed || 0} / Δ${this.state.cmpDiff?.products?.summary?.changed || 0}`} />
              <Chip label={`Combos: +${this.state.cmpDiff?.combos?.summary?.added || 0} / -${this.state.cmpDiff?.combos?.summary?.removed || 0} / Δ${this.state.cmpDiff?.combos?.summary?.changed || 0}`} />
            </Stack>

            <Box
              sx={{
                position: 'sticky',
                top: 0,   // under DialogTitle (mobile/desktop)
                zIndex: 2,
                bgcolor: 'background.paper',
                borderBottom: 1,
                borderColor: 'divider',
                mt: -0.5   // ⬅️ pulls tabs closer to title
              }}
            >
              <Tabs
                value={this.state.cmpTab}
                onChange={(e, v) => this.setState({ cmpTab: v })}
                variant="fullWidth"
              >
                <Tab label="Products" />
                <Tab label="Combos" />
              </Tabs>
            </Box>

            {/* Products */}
            {this.state.cmpTab === 0 && (
              <Stack spacing={2} sx={{ mt: 2 }}>
                {/* Added */}
                <Paper variant="outlined" sx={{ borderColor: 'success.main' }}>
                  <Box sx={{ bgcolor: 'success.light', px: 1, py: 0.5 }}>
                    <Typography variant="subtitle2">Added</Typography>
                  </Box>
                  <Table size="small" stickyHeader>
                    <TableHead
                      sx={{
                        '& .MuiTableCell-root': {
                          fontWeight: 'bold',
                          backgroundColor: 'grey.100', // optional subtle background
                        },
                      }}
                    >
                      <TableRow>
                        <TableCell>Name</TableCell><TableCell>SKU</TableCell>
                        <TableCell align="right">Price</TableCell>
                        <TableCell>Active</TableCell>
                        <TableCell>Currency</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(this.state.cmpDiff?.products?.added || []).map((r, i)=>(
                        <TableRow
                          key={`pa_${i}`}
                          sx={{ bgcolor: 'success.lighter' }}
                        >
                          <TableCell>{this.displayName(r)}</TableCell>
                          <TableCell>{this.displaySku(r)}</TableCell>
                          <TableCell align="right">{(r.price != null && r.price !== '' ? r.price : '—')}</TableCell>
                          <TableCell>{r.isActive ? 'Yes' : 'No'}</TableCell>
                          <TableCell>{toCurrencyName(r.currency ?? this.state.cmpBase?.currency)}</TableCell>
                        </TableRow>
                      ))}
                      {(!this.state.cmpDiff?.products?.added?.length) && (
                        <TableRow><TableCell colSpan={5}><Typography variant="body2" color="text.secondary">None</Typography></TableCell></TableRow>
                      )}
                    </TableBody>
                  </Table>
                </Paper>

                {/* Removed */}
                <Paper variant="outlined" sx={{ borderColor: 'success.main' }}>
                  <Box sx={{ bgcolor: 'error.light', px: 1, py: 0.5 }}>
                    <Typography variant="subtitle2">Removed</Typography>
                  </Box>
                  <Table size="small" stickyHeader>
                    <TableHead
                      sx={{
                        '& .MuiTableCell-root': {
                          fontWeight: 'bold',
                          backgroundColor: 'grey.100', // optional subtle background
                        },
                      }}
                    >
                      <TableRow>
                        <TableCell>Name</TableCell><TableCell>SKU</TableCell>
                        <TableCell align="right">Price</TableCell>
                        <TableCell>Active</TableCell>
                        <TableCell>Currency</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(this.state.cmpDiff?.products?.removed || []).map((r, i)=>(
                        <TableRow
                          key={`pr_${i}`}
                          sx={{ bgcolor: 'error.lighter' }}
                        >
                          <TableCell>{this.displayName(r)}</TableCell>
                          <TableCell>{this.displaySku(r)}</TableCell>
                          <TableCell align="right">{r.price}</TableCell>
                          <TableCell>{r.isActive ? 'Yes' : 'No'}</TableCell>
                          <TableCell>{toCurrencyName(r.currency ?? this.state.cmpOther?.currency)}</TableCell>
                        </TableRow>
                      ))}
                      {(!this.state.cmpDiff?.products?.removed?.length) && (
                        <TableRow><TableCell colSpan={5}><Typography variant="body2" color="text.secondary">None</Typography></TableCell></TableRow>
                      )}
                    </TableBody>
                  </Table>
                </Paper>

                {/* Changed */}
                <Paper variant="outlined" sx={{ borderColor: 'success.main' }}>
                  <Box sx={{ bgcolor: 'warning.light', px: 1, py: 0.5 }}>
                    <Typography variant="subtitle2">Changed</Typography>
                  </Box>
                  <Table size="small" stickyHeader>
                    <TableHead
                      sx={{
                        '& .MuiTableCell-root': {
                          fontWeight: 'bold',
                          backgroundColor: 'grey.100', // optional subtle background
                        },
                      }}
                    >
                      <TableRow>
                        <TableCell>Name</TableCell><TableCell>SKU</TableCell>
                        <TableCell align="right">Prev → Curr (Price)</TableCell>
                        <TableCell>Prev → Curr (Active)</TableCell>
                        <TableCell>Prev → Curr (Currency)</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(this.state.cmpDiff?.products?.changed || []).map((r, i)=>(
                        <TableRow
                          key={`pc_${i}`}
                          sx={{ bgcolor: 'warning.lighter' }}
                        >
                          <TableCell>{this.displayName(r.to) || this.displayName(r.from)}</TableCell>
                          <TableCell>{this.displaySku(r.to)  || this.displaySku(r.from)}</TableCell>
                          <TableCell align="right"
                            sx={{ color: r.from.price !== r.to.price ? 'warning.dark' : 'text.primary' }}
                          >
                            {r.from.price} → {r.to.price}
                          </TableCell>
                          <TableCell>{(r.from.isActive?'Yes':'No')} → {(r.to.isActive?'Yes':'No')}</TableCell>
                          <TableCell>{toCurrencyName(r.from.currency)} → {toCurrencyName(r.to.currency)}</TableCell>
                        </TableRow>
                      ))}
                      {(!this.state.cmpDiff?.products?.changed?.length) && (
                        <TableRow><TableCell colSpan={5}><Typography variant="body2" color="text.secondary">None</Typography></TableCell></TableRow>
                      )}
                    </TableBody>
                  </Table>
                </Paper>
              </Stack>
            )}

            {/* Combos (same structure as Products) */}
            {this.state.cmpTab === 1 && (
              <Stack spacing={2} sx={{ mt: 2 }}>
                {/* Added */}
                <Paper variant="outlined" sx={{ borderColor: 'success.main' }}>
                  <Box sx={{ bgcolor: 'success.light', px: 1, py: 0.5 }}>
                    <Typography variant="subtitle2">Added</Typography>
                  </Box>
                  <Table size="small" stickyHeader>
                    <TableHead
                      sx={{
                        '& .MuiTableCell-root': {
                          fontWeight: 'bold',
                          backgroundColor: 'grey.100', // optional subtle background
                        },
                      }}
                    >
                      <TableRow>
                        <TableCell>Name</TableCell><TableCell>SKU</TableCell>
                        <TableCell align="right">Price</TableCell>
                        <TableCell>Active</TableCell>
                        <TableCell>Currency</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(this.state.cmpDiff?.combos?.added || []).map((r, i)=>(
                        <TableRow
                          key={`ca_${i}`}
                          sx={{ bgcolor: 'success.lighter' }}
                        >
                          <TableCell>{this.displayName(r)}</TableCell>
                          <TableCell>{this.displaySku(r)}</TableCell>
                          <TableCell align="right">{r.price}</TableCell>
                          <TableCell>{r.isActive ? 'Yes' : 'No'}</TableCell>
                          <TableCell>{toCurrencyName(r.currency ?? this.state.cmpBase?.currency)}</TableCell>
                        </TableRow>
                      ))}
                      {(!this.state.cmpDiff?.combos?.added?.length) && (
                        <TableRow><TableCell colSpan={5}><Typography variant="body2" color="text.secondary">None</Typography></TableCell></TableRow>
                      )}
                    </TableBody>
                  </Table>
                </Paper>

                {/* Removed */}
                <Paper variant="outlined" sx={{ borderColor: 'success.main' }}>
                  <Box sx={{ bgcolor: 'error.light', px: 1, py: 0.5 }}>
                    <Typography variant="subtitle2">Removed</Typography>
                  </Box>
                  <Table size="small" stickyHeader>
                    <TableHead
                      sx={{
                        '& .MuiTableCell-root': {
                          fontWeight: 'bold',
                          backgroundColor: 'grey.100', // optional subtle background
                        },
                      }}
                    >
                      <TableRow>
                        <TableCell>Name</TableCell><TableCell>SKU</TableCell>
                        <TableCell align="right">Price</TableCell>
                        <TableCell>Active</TableCell>
                        <TableCell>Currency</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(this.state.cmpDiff?.combos?.removed || []).map((r, i)=>(
                        <TableRow
                          key={`cr_${i}`}
                          sx={{ bgcolor: 'error.lighter' }}
                        >
                          <TableCell>{this.displayName(r)}</TableCell>
                          <TableCell>{this.displaySku(r)}</TableCell>
                          <TableCell align="right">{r.price}</TableCell>
                          <TableCell>{r.isActive ? 'Yes' : 'No'}</TableCell>
                          <TableCell>{toCurrencyName(r.currency ?? this.state.cmpOther?.currency)}</TableCell>
                        </TableRow>
                      ))}
                      {(!this.state.cmpDiff?.combos?.removed?.length) && (
                        <TableRow><TableCell colSpan={5}><Typography variant="body2" color="text.secondary">None</Typography></TableCell></TableRow>
                      )}
                    </TableBody>
                  </Table>
                </Paper>

                {/* Changed */}
                <Paper variant="outlined" sx={{ borderColor: 'success.main' }}>
                  <Box sx={{ bgcolor: 'warning.light', px: 1, py: 0.5 }}>
                    <Typography variant="subtitle2">Changed</Typography>
                  </Box>
                  <Table size="small" stickyHeader>
                    <TableHead
                      sx={{
                        '& .MuiTableCell-root': {
                          fontWeight: 'bold',
                          backgroundColor: 'grey.100', // optional subtle background
                        },
                      }}
                    >
                      <TableRow>
                        <TableCell>Name</TableCell><TableCell>SKU</TableCell>
                        <TableCell align="right">Prev → Curr (Price)</TableCell>
                        <TableCell>Prev → Curr (Active)</TableCell>
                        <TableCell>Prev → Curr (Currency)</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(this.state.cmpDiff?.combos?.changed || []).map((r, i)=>(
                        <TableRow
                          key={`cc_${i}`}
                          sx={{ bgcolor: 'warning.lighter' }}
                        >
                          <TableCell>{this.displayName(r.to) || this.displayName(r.from)}</TableCell>
                          <TableCell>{this.displaySku(r.to)  || this.displaySku(r.from)}</TableCell>
                          <TableCell align="right"
                            sx={{ color: r.from.price !== r.to.price ? 'warning.dark' : 'text.primary' }}
                          >
                            {r.from.price} → {r.to.price}
                          </TableCell>
                          <TableCell>{(r.from.isActive?'Yes':'No')} → {(r.to.isActive?'Yes':'No')}</TableCell>
                          <TableCell>{toCurrencyName(r.from.currency)} → {toCurrencyName(r.to.currency)}</TableCell>
                        </TableRow>
                      ))}
                      {(!this.state.cmpDiff?.combos?.changed?.length) && (
                        <TableRow><TableCell colSpan={5}><Typography variant="body2" color="text.secondary">None</Typography></TableCell></TableRow>
                      )}
                    </TableBody>
                  </Table>
                </Paper>
              </Stack>
            )}
          </DialogContent>
        </Dialog>

        {/* Confirm Discard Dialog */}
        <Dialog open={this.state.confirmCloseOpen} onClose={() => {}}>
          <DialogTitle>Discard changes?</DialogTitle>
          <DialogContent dividers>
            <Typography variant='body2'>You have unsaved changes. Are you sure you want to close without saving?</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>this.setState({ confirmCloseOpen:false })}>Cancel</Button>
            <Button color='error' variant='contained' onClick={this.discardChangesAndClose}>Discard</Button>
          </DialogActions>
        </Dialog>

        {/* Snack */}
        <Snackbar
          open={this.state.snack.open}
          autoHideDuration={4000}
          onClose={()=> this.setState({ snack: { ...this.state.snack, open:false } })}
          anchorOrigin={{ vertical:'bottom', horizontal:'center' }}
        >
          <Alert onClose={()=> this.setState({ snack: { ...this.state.snack, open:false } })} severity={this.state.snack.severity} sx={{ width: '100%' }}>
            {this.state.snack.message}
          </Alert>
        </Snackbar>

        {this.state.copySubmitting && (
          <Box
            sx={{
              position: 'fixed',
              inset: 0,
              bgcolor: 'rgba(0,0,0,0.35)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 2000,
              flexDirection: 'column'
            }}
          >
            <CircularProgress />
            <Typography sx={{ mt: 2, color: '#fff' }}>
              Copying company list…
            </Typography>
          </Box>
        )}
      </div>
    );
  }
}